var map = {
	"./downloaded_images/Abbadog-menu.png": 15583,
	"./downloaded_images/Abbadog.png": 89895,
	"./downloaded_images/Absolute_Barrier_EX_SkillIcon.png": 41991,
	"./downloaded_images/Acegon-menu.png": 52546,
	"./downloaded_images/Acegon.png": 24208,
	"./downloaded_images/Aferaid-menu.png": 88957,
	"./downloaded_images/Aferaid.png": 44317,
	"./downloaded_images/Aferaid_Cosmic.png": 73864,
	"./downloaded_images/Agita-menu.png": 14467,
	"./downloaded_images/Agita.png": 19451,
	"./downloaded_images/Algon-menu.png": 78616,
	"./downloaded_images/Algon.png": 90310,
	"./downloaded_images/Anima-menu.png": 11455,
	"./downloaded_images/Anima.png": 36071,
	"./downloaded_images/Antarzen-menu.png": 72,
	"./downloaded_images/Antarzen.png": 11222,
	"./downloaded_images/Antlorm-menu.png": 3730,
	"./downloaded_images/Antlorm.png": 9440,
	"./downloaded_images/Antlorm_Cosmic.png": 38507,
	"./downloaded_images/Apple.png": 2331,
	"./downloaded_images/Aqua_Siphon_EX_SkillIcon.png": 78086,
	"./downloaded_images/Arcane_Curse_EX_SkillIcon.png": 55533,
	"./downloaded_images/Arcane_Magic_EX_SkillIcon.png": 43592,
	"./downloaded_images/Arcane_Siphon_EX_SkillIcon.png": 98512,
	"./downloaded_images/Arctivore2.png": 99068,
	"./downloaded_images/Arctivore_(Extinction)-menu.png": 91551,
	"./downloaded_images/Arispauva-menu.png": 68293,
	"./downloaded_images/Arispauva.png": 72965,
	"./downloaded_images/Arqua2.png": 3745,
	"./downloaded_images/Arqua_(Extinction)-menu.png": 56488,
	"./downloaded_images/Attack_Stat_Icon.png": 17516,
	"./downloaded_images/Auga-menu.png": 89829,
	"./downloaded_images/Auga.png": 68133,
	"./downloaded_images/Auga_Cosmic.png": 30176,
	"./downloaded_images/Babicle-menu.png": 49261,
	"./downloaded_images/Babicle.png": 62669,
	"./downloaded_images/Babicle_Cosmic.png": 44408,
	"./downloaded_images/Bactoul-menu.png": 47137,
	"./downloaded_images/Bactoul.png": 80337,
	"./downloaded_images/Bactoul_Cosmic.png": 46444,
	"./downloaded_images/Baguette.png": 7074,
	"./downloaded_images/Baloompa-menu.png": 69400,
	"./downloaded_images/Baloompa.png": 93862,
	"./downloaded_images/Baloompa_Cosmic.png": 87673,
	"./downloaded_images/Banana.png": 91232,
	"./downloaded_images/Barboraco-menu.png": 93114,
	"./downloaded_images/Barboraco.png": 22280,
	"./downloaded_images/Barboraco_Cosmic.png": 45987,
	"./downloaded_images/Barrier_EX_SkillIcon.png": 20437,
	"./downloaded_images/Basil-menu.png": 51920,
	"./downloaded_images/Basil.png": 71838,
	"./downloaded_images/Battle_Roar_EX_SkillIcon.png": 55253,
	"./downloaded_images/Bedam2.png": 26852,
	"./downloaded_images/Bedam_(Extinction)-menu.png": 90839,
	"./downloaded_images/Behilda-menu.png": 11062,
	"./downloaded_images/Behilda.png": 59684,
	"./downloaded_images/Bind_Status_Icon.png": 17665,
	"./downloaded_images/Bira-menu.png": 63263,
	"./downloaded_images/Bira.png": 57703,
	"./downloaded_images/Biralo-menu.png": 79462,
	"./downloaded_images/Biralo.png": 85652,
	"./downloaded_images/Bisina-menu.png": 15119,
	"./downloaded_images/Bisina.png": 10391,
	"./downloaded_images/Bite_EX_SkillIcon.png": 75564,
	"./downloaded_images/Black_Flame_EX_SkillIcon.png": 31385,
	"./downloaded_images/Blaze_EX_SkillIcon.png": 94218,
	"./downloaded_images/Blazetilia-menu.png": 9340,
	"./downloaded_images/Blazetilia.png": 57754,
	"./downloaded_images/Blazetilia_Cosmic.png": 81565,
	"./downloaded_images/Blazing_Mineral_EX_SkillIcon.png": 12452,
	"./downloaded_images/Blimpapa-menu.png": 76299,
	"./downloaded_images/Blimpapa.png": 76003,
	"./downloaded_images/Blimpapa_Cosmic.png": 19094,
	"./downloaded_images/Blit-menu.png": 69388,
	"./downloaded_images/Blit.png": 29674,
	"./downloaded_images/Blit_Cosmic.png": 73325,
	"./downloaded_images/Blitz_Barrier_EX_SkillIcon.png": 28889,
	"./downloaded_images/Blizstrong-menu.png": 35109,
	"./downloaded_images/Blizstrong.png": 23781,
	"./downloaded_images/Blizzarm-menu.png": 79974,
	"./downloaded_images/Blizzarm.png": 1748,
	"./downloaded_images/Blizzaur-menu.png": 68948,
	"./downloaded_images/Blizzaur.png": 26162,
	"./downloaded_images/Blooming_Spores_EX_SkillIcon.png": 89802,
	"./downloaded_images/Bloomriol-menu.png": 75470,
	"./downloaded_images/Bloomriol.png": 34812,
	"./downloaded_images/Bloomriol_Cosmic.png": 17815,
	"./downloaded_images/Bloopish-menu.png": 15463,
	"./downloaded_images/Bloopish.png": 11471,
	"./downloaded_images/Bloopish_Cosmic.png": 14178,
	"./downloaded_images/Blublub-menu.png": 38023,
	"./downloaded_images/Blublub.png": 30415,
	"./downloaded_images/Blublub_Cosmic.png": 93250,
	"./downloaded_images/Blue_Charge_EX_SkillIcon.png": 26039,
	"./downloaded_images/Blue_Mirror_EX_SkillIcon.png": 50816,
	"./downloaded_images/Bogarp2.png": 24780,
	"./downloaded_images/Bogarp_(Extinction)-menu.png": 42767,
	"./downloaded_images/Boilgog-menu.png": 50930,
	"./downloaded_images/Boilgog.png": 88576,
	"./downloaded_images/Bolzen-menu.png": 11613,
	"./downloaded_images/Bolzen.png": 26877,
	"./downloaded_images/Bombargrof-menu.png": 81356,
	"./downloaded_images/Bombargrof.png": 43690,
	"./downloaded_images/Bombargrof_Cosmic.png": 74061,
	"./downloaded_images/Bomblasta-menu.png": 72324,
	"./downloaded_images/Bomblasta.png": 2018,
	"./downloaded_images/Bomblasta_Cosmic.png": 57173,
	"./downloaded_images/Bomriol-menu.png": 20099,
	"./downloaded_images/Bomriol.png": 65691,
	"./downloaded_images/Bomriol_Cosmic.png": 30558,
	"./downloaded_images/Boscage-menu.png": 55611,
	"./downloaded_images/Boscage.png": 28403,
	"./downloaded_images/Bouldcran-menu.png": 57667,
	"./downloaded_images/Bouldcran.png": 92987,
	"./downloaded_images/Bouldcran_Cosmic.png": 73310,
	"./downloaded_images/Bouldion-menu.png": 33495,
	"./downloaded_images/Bouldion.png": 59679,
	"./downloaded_images/Bouldion_Cosmic.png": 48978,
	"./downloaded_images/Braccus-menu.png": 30450,
	"./downloaded_images/Braccus.png": 24352,
	"./downloaded_images/Branipus-menu.png": 78301,
	"./downloaded_images/Branipus.png": 1693,
	"./downloaded_images/Branipus_Cosmic.png": 10152,
	"./downloaded_images/Brauncer-menu.png": 99469,
	"./downloaded_images/Brauncer.png": 66605,
	"./downloaded_images/Brauncer_Cosmic.png": 11960,
	"./downloaded_images/Briar-menu.png": 94635,
	"./downloaded_images/Briar.png": 47491,
	"./downloaded_images/Broshield2.png": 85877,
	"./downloaded_images/Broshield_(Extinction)-menu.png": 41876,
	"./downloaded_images/Brumenie-menu.png": 47512,
	"./downloaded_images/Brumenie.png": 21798,
	"./downloaded_images/Brumenie_Cosmic.png": 93113,
	"./downloaded_images/Brumtler-menu.png": 22,
	"./downloaded_images/Brumtler.png": 35780,
	"./downloaded_images/Brumtler_Cosmic.png": 31119,
	"./downloaded_images/Bubble_Attack_EX_SkillIcon.png": 10693,
	"./downloaded_images/Bulbrit-menu.png": 72461,
	"./downloaded_images/Bulbrit.png": 70669,
	"./downloaded_images/Bulbrit_Cosmic.png": 95736,
	"./downloaded_images/Bullet_Seed_EX_SkillIcon.png": 98582,
	"./downloaded_images/Bullogan-menu.png": 96503,
	"./downloaded_images/Bullogan.png": 92063,
	"./downloaded_images/Bullogan_Cosmic.png": 95026,
	"./downloaded_images/Burn_EX_SkillIcon.png": 9463,
	"./downloaded_images/Burn_Status_Icon.png": 49787,
	"./downloaded_images/Bushnome-menu.png": 93780,
	"./downloaded_images/Bushnome.png": 62866,
	"./downloaded_images/Bushnome_Cosmic.png": 77829,
	"./downloaded_images/Byeol-menu.png": 15796,
	"./downloaded_images/Byeol.png": 59282,
	"./downloaded_images/Cadeto-menu.png": 2649,
	"./downloaded_images/Cadeto.png": 13513,
	"./downloaded_images/Cadeto_Cosmic.png": 88820,
	"./downloaded_images/CadiumWarp.png": 41898,
	"./downloaded_images/Caelesa-menu.png": 86367,
	"./downloaded_images/Caelesa.png": 40903,
	"./downloaded_images/Calfter-menu.png": 67986,
	"./downloaded_images/Calfter.png": 51104,
	"./downloaded_images/Calfter_Cosmic.png": 56619,
	"./downloaded_images/Calplex-menu.png": 33998,
	"./downloaded_images/Calplex.png": 46140,
	"./downloaded_images/Calplex_Cosmic.png": 58039,
	"./downloaded_images/Candly-menu.png": 85906,
	"./downloaded_images/Candly.png": 48224,
	"./downloaded_images/Candly_Cosmic.png": 10891,
	"./downloaded_images/Canele.png": 27221,
	"./downloaded_images/Caninui-menu.png": 23084,
	"./downloaded_images/Caninui.png": 75434,
	"./downloaded_images/Caninui_Cosmic.png": 56141,
	"./downloaded_images/Carcaros-menu.png": 67645,
	"./downloaded_images/Carcaros.png": 54845,
	"./downloaded_images/Carnagrius2.png": 17524,
	"./downloaded_images/Carnagrius_(Extinction)-menu.png": 45383,
	"./downloaded_images/Centeror-menu.png": 87187,
	"./downloaded_images/Centeror.png": 84523,
	"./downloaded_images/Centeror_Cosmic.png": 19758,
	"./downloaded_images/Cerebrius-menu.png": 68779,
	"./downloaded_images/Cerebrius.png": 34979,
	"./downloaded_images/Cerebrius_Cosmic.png": 54230,
	"./downloaded_images/Chaparral-menu.png": 74919,
	"./downloaded_images/Chaparral.png": 75471,
	"./downloaded_images/Chibbit-menu.png": 7432,
	"./downloaded_images/Chibbit.png": 35766,
	"./downloaded_images/Chibbit_Cosmic.png": 53993,
	"./downloaded_images/Chirrent-menu.png": 40688,
	"./downloaded_images/Chirrent.png": 67262,
	"./downloaded_images/Chirrent_Cosmic.png": 30081,
	"./downloaded_images/Chocolate-Cake.png": 16072,
	"./downloaded_images/Chocolate-Muffin.png": 23959,
	"./downloaded_images/Chowser-menu.png": 94858,
	"./downloaded_images/Chowser.png": 57816,
	"./downloaded_images/Chowser_Cosmic.png": 70227,
	"./downloaded_images/Cleanse_EX_SkillIcon.png": 13619,
	"./downloaded_images/Cloddy-menu.png": 81724,
	"./downloaded_images/Cloddy.png": 15578,
	"./downloaded_images/Cloddy_Cosmic.png": 68701,
	"./downloaded_images/Columbra2.png": 66142,
	"./downloaded_images/Columbra_(Extinction)-menu.png": 3721,
	"./downloaded_images/Combo_EX_SkillIcon.png": 84008,
	"./downloaded_images/Combustion_EX_SkillIcon.png": 82029,
	"./downloaded_images/Conflagration_EX_SkillIcon.png": 41251,
	"./downloaded_images/Confusion_Status_Icon.png": 28952,
	"./downloaded_images/Constrict_EX_SkillIcon.png": 29611,
	"./downloaded_images/Coral-menu.png": 34790,
	"./downloaded_images/Coral.png": 75668,
	"./downloaded_images/Corrosive_Breeze_EX_SkillIcon.png": 68442,
	"./downloaded_images/Corrupted_Mineral_EX_SkillIcon.png": 95687,
	"./downloaded_images/Couplet-menu.png": 61419,
	"./downloaded_images/Couplet.png": 13027,
	"./downloaded_images/Couplet_Cosmic.png": 71798,
	"./downloaded_images/Cranillow-menu.png": 67608,
	"./downloaded_images/Cranillow.png": 1126,
	"./downloaded_images/Cranillow_Cosmic.png": 72441,
	"./downloaded_images/Cranoad-menu.png": 29397,
	"./downloaded_images/Cranoad.png": 55125,
	"./downloaded_images/Cranoad_Cosmic.png": 21840,
	"./downloaded_images/Cream-Puff.png": 33633,
	"./downloaded_images/Creep_EX_SkillIcon.png": 78067,
	"./downloaded_images/Crescent_Wings_EX_SkillIcon.png": 70869,
	"./downloaded_images/Crimson_Blast_EX_SkillIcon.png": 46150,
	"./downloaded_images/Cromeon-menu.png": 68826,
	"./downloaded_images/Cromeon.png": 48168,
	"./downloaded_images/Cromeon_Cosmic.png": 8451,
	"./downloaded_images/Croncho-menu.png": 82123,
	"./downloaded_images/Croncho.png": 99683,
	"./downloaded_images/Croncho_Cosmic.png": 41622,
	"./downloaded_images/Croo-menu.png": 52232,
	"./downloaded_images/Croo.png": 39222,
	"./downloaded_images/Croo_Cosmic.png": 21129,
	"./downloaded_images/Cruff-menu.png": 24595,
	"./downloaded_images/Cruff.png": 63371,
	"./downloaded_images/Cruff_Cosmic.png": 41934,
	"./downloaded_images/Crushing_Boulder_EX_SkillIcon.png": 52729,
	"./downloaded_images/Cryzzard-menu.png": 18210,
	"./downloaded_images/Cryzzard.png": 69488,
	"./downloaded_images/Cubdy-menu.png": 78202,
	"./downloaded_images/Cubdy.png": 97512,
	"./downloaded_images/Cubdy_Cosmic.png": 69763,
	"./downloaded_images/Cuisizle-menu.png": 36583,
	"./downloaded_images/Cuisizle.png": 36207,
	"./downloaded_images/Cuisizle_Cosmic.png": 93282,
	"./downloaded_images/Cursed_Status_Icon.png": 97422,
	"./downloaded_images/Cyclone_EX_SkillIcon.png": 17375,
	"./downloaded_images/Dalsae-menu.png": 85859,
	"./downloaded_images/Dalsae.png": 87835,
	"./downloaded_images/Darine2.png": 37882,
	"./downloaded_images/Darine_(Extinction)-menu.png": 92157,
	"./downloaded_images/Dark_Flame_EX_SkillIcon.png": 41038,
	"./downloaded_images/Dark_Flow_EX_SkillIcon.png": 66987,
	"./downloaded_images/Dark_Mist_EX_SkillIcon.png": 65722,
	"./downloaded_images/Darkness_EX_SkillIcon.png": 73745,
	"./downloaded_images/Deebuz-menu.png": 65824,
	"./downloaded_images/Deebuz.png": 48558,
	"./downloaded_images/Deebuz_Cosmic.png": 28113,
	"./downloaded_images/Deember-menu.png": 44305,
	"./downloaded_images/Deember.png": 86593,
	"./downloaded_images/Deember_Cosmic.png": 15868,
	"./downloaded_images/Defense_Stat_Icon.png": 83780,
	"./downloaded_images/Demotivated_Status_Icon.png": 92418,
	"./downloaded_images/Devoul-menu.png": 5410,
	"./downloaded_images/Devoul.png": 98576,
	"./downloaded_images/Devoul_Cosmic.png": 37883,
	"./downloaded_images/Deyam-menu.png": 3107,
	"./downloaded_images/Deyam.png": 47931,
	"./downloaded_images/Deyama-menu.png": 30652,
	"./downloaded_images/Deyama.png": 38682,
	"./downloaded_images/Dichala-menu.png": 87259,
	"./downloaded_images/Dichala.png": 11411,
	"./downloaded_images/Dinja-menu.png": 82177,
	"./downloaded_images/Dinja.png": 11729,
	"./downloaded_images/Disintegrate_EX_SkillIcon.png": 49481,
	"./downloaded_images/Dispell_EX_SkillIcon.png": 63893,
	"./downloaded_images/Disruption_Ray_EX_SkillIcon.png": 14664,
	"./downloaded_images/Divette-menu.png": 40022,
	"./downloaded_images/Divette.png": 63972,
	"./downloaded_images/Domigator-menu.png": 52111,
	"./downloaded_images/Domigator.png": 47159,
	"./downloaded_images/Domigator_Cosmic.png": 42394,
	"./downloaded_images/Donut.png": 19775,
	"./downloaded_images/Double_Slash_EX_SkillIcon.png": 26341,
	"./downloaded_images/Dracly-menu.png": 63846,
	"./downloaded_images/Dracly.png": 64340,
	"./downloaded_images/Dracly_Cosmic.png": 9311,
	"./downloaded_images/Dracon-menu.png": 69760,
	"./downloaded_images/Dracon.png": 69710,
	"./downloaded_images/Drain_EX_SkillIcon.png": 15420,
	"./downloaded_images/Draniphant-menu.png": 59542,
	"./downloaded_images/Draniphant.png": 77732,
	"./downloaded_images/Draniphant_Cosmic.png": 91215,
	"./downloaded_images/Drare-menu.png": 83287,
	"./downloaded_images/Drare.png": 7007,
	"./downloaded_images/Dratter-menu.png": 78845,
	"./downloaded_images/Dratter.png": 64317,
	"./downloaded_images/Dreaver-menu.png": 91802,
	"./downloaded_images/Dreaver.png": 33896,
	"./downloaded_images/Dreaver_Cosmic.png": 59395,
	"./downloaded_images/Dreddiful-menu.png": 82896,
	"./downloaded_images/Dreddiful.png": 9566,
	"./downloaded_images/Dreddiful_Cosmic.png": 61377,
	"./downloaded_images/Dredmore-menu.png": 83849,
	"./downloaded_images/Dredmore.png": 37145,
	"./downloaded_images/Dredmore_Cosmic.png": 72772,
	"./downloaded_images/Dredrone-menu.png": 66826,
	"./downloaded_images/Dredrone.png": 68184,
	"./downloaded_images/Dredrone_Cosmic.png": 339,
	"./downloaded_images/Drill_EX_SkillIcon.png": 97747,
	"./downloaded_images/Duh-menu.png": 74866,
	"./downloaded_images/Duh.png": 47040,
	"./downloaded_images/Duktar-menu.png": 82400,
	"./downloaded_images/Duktar.png": 12014,
	"./downloaded_images/Durtacles-menu.png": 57364,
	"./downloaded_images/Durtacles.png": 44466,
	"./downloaded_images/Durtacles_Cosmic.png": 96197,
	"./downloaded_images/EMP_EX_SkillIcon.png": 10828,
	"./downloaded_images/Egg-Tart.png": 23600,
	"./downloaded_images/Electric_Bomb_EX_SkillIcon.png": 41994,
	"./downloaded_images/Electric_Current_EX_SkillIcon.png": 68527,
	"./downloaded_images/Electric_Force_EX_SkillIcon.png": 19341,
	"./downloaded_images/Electric_Siphon_EX_SkillIcon.png": 5491,
	"./downloaded_images/Electric_Storm_EX_SkillIcon.png": 79515,
	"./downloaded_images/Electric_Type_Icon.png": 34251,
	"./downloaded_images/Electrode_EX_SkillIcon.png": 20033,
	"./downloaded_images/Elemental_Up_EX_SkillIcon.png": 17045,
	"./downloaded_images/Enercer-menu.png": 23701,
	"./downloaded_images/Enercer.png": 62517,
	"./downloaded_images/Enercer_Cosmic.png": 18000,
	"./downloaded_images/Energy_Strike_EX_SkillIcon.png": 84893,
	"./downloaded_images/Eqo-menu.png": 45296,
	"./downloaded_images/Eqo.png": 7134,
	"./downloaded_images/Eqo_Cosmic.png": 12129,
	"./downloaded_images/Eqoloptera-menu.png": 63211,
	"./downloaded_images/Eqoloptera.png": 3267,
	"./downloaded_images/Eqoloptera_Cosmic.png": 36950,
	"./downloaded_images/Eternal_Darkness_EX_SkillIcon.png": 63375,
	"./downloaded_images/Eurus-menu.png": 10299,
	"./downloaded_images/Eurus.png": 531,
	"./downloaded_images/Excravator-menu.png": 6240,
	"./downloaded_images/Excravator.png": 91502,
	"./downloaded_images/Excravator_Cosmic.png": 41489,
	"./downloaded_images/Explosion_EX_SkillIcon.png": 73865,
	"./downloaded_images/Explosive_Water_EX_SkillIcon.png": 473,
	"./downloaded_images/Fainglori-menu.png": 44364,
	"./downloaded_images/Fainglori.png": 61290,
	"./downloaded_images/Fainglori_Cosmic.png": 33261,
	"./downloaded_images/Fandiose-menu.png": 82368,
	"./downloaded_images/Fandiose.png": 59342,
	"./downloaded_images/Fandiose_Cosmic.png": 1457,
	"./downloaded_images/Fane-menu.png": 69523,
	"./downloaded_images/Fane.png": 61899,
	"./downloaded_images/Fanling-menu.png": 16478,
	"./downloaded_images/Fanling.png": 9548,
	"./downloaded_images/Fanling_Cosmic.png": 13863,
	"./downloaded_images/Faucefant-menu.png": 96084,
	"./downloaded_images/Faucefant.png": 18354,
	"./downloaded_images/Faucefant_Cosmic.png": 89189,
	"./downloaded_images/Fauna_EX_SkillIcon.png": 81175,
	"./downloaded_images/Felarnia-menu.png": 1847,
	"./downloaded_images/Felarnia.png": 52511,
	"./downloaded_images/Felclaw-menu.png": 57995,
	"./downloaded_images/Felclaw.png": 96387,
	"./downloaded_images/Feliblanqo-menu.png": 63120,
	"./downloaded_images/Feliblanqo.png": 25726,
	"./downloaded_images/Felicient2.png": 25998,
	"./downloaded_images/Felicient_(Extinction)-menu.png": 64697,
	"./downloaded_images/Ferodile2.png": 17011,
	"./downloaded_images/Ferodile_(Extinction)-menu.png": 87986,
	"./downloaded_images/Fire_Barrier_EX_SkillIcon.png": 56046,
	"./downloaded_images/Fire_Cage_EX_SkillIcon.png": 71475,
	"./downloaded_images/Fire_Claw_EX_SkillIcon.png": 13792,
	"./downloaded_images/Fire_Cross_EX_SkillIcon.png": 38697,
	"./downloaded_images/Fire_Siphon_EX_SkillIcon.png": 96218,
	"./downloaded_images/Fire_Stigma_EX_SkillIcon.png": 74050,
	"./downloaded_images/Fire_Type_Icon.png": 50198,
	"./downloaded_images/Fire_Will_EX_SkillIcon.png": 41731,
	"./downloaded_images/Fireball_EX_SkillIcon.png": 50003,
	"./downloaded_images/Fistuff-menu.png": 28914,
	"./downloaded_images/Fistuff.png": 736,
	"./downloaded_images/Fistuff_Cosmic.png": 76555,
	"./downloaded_images/Flame_Breath_EX_SkillIcon.png": 38144,
	"./downloaded_images/Flame_Column_EX_SkillIcon.png": 10712,
	"./downloaded_images/Flame_EX_SkillIcon.png": 72509,
	"./downloaded_images/Flan.png": 16068,
	"./downloaded_images/Flizard-menu.png": 74345,
	"./downloaded_images/Flizard.png": 62649,
	"./downloaded_images/Flizard_Cosmic.png": 38308,
	"./downloaded_images/Florauga-menu.png": 13758,
	"./downloaded_images/Florauga.png": 3724,
	"./downloaded_images/Florauga_Cosmic.png": 16167,
	"./downloaded_images/Floreina-menu.png": 22843,
	"./downloaded_images/Floreina.png": 67475,
	"./downloaded_images/Floreina_Cosmic.png": 81510,
	"./downloaded_images/Florozard-menu.png": 31004,
	"./downloaded_images/Florozard.png": 33146,
	"./downloaded_images/Flotter-menu.png": 44839,
	"./downloaded_images/Flotter.png": 82799,
	"./downloaded_images/Focus_Seed_EX_SkillIcon.png": 96326,
	"./downloaded_images/Folicurse-menu.png": 48597,
	"./downloaded_images/Folicurse.png": 24213,
	"./downloaded_images/Folicurse_Cosmic.png": 55056,
	"./downloaded_images/Fona2.png": 12967,
	"./downloaded_images/Fona_(Extinction)-menu.png": 70174,
	"./downloaded_images/Foreer-menu.png": 23690,
	"./downloaded_images/Foreer.png": 24568,
	"./downloaded_images/Forest_Energy_EX_SkillIcon.png": 892,
	"./downloaded_images/Forest_Song_EX_SkillIcon.png": 12965,
	"./downloaded_images/Fortank-menu.png": 93588,
	"./downloaded_images/Fortank.png": 88146,
	"./downloaded_images/Fortank_Cosmic.png": 22341,
	"./downloaded_images/Fortle-menu.png": 21881,
	"./downloaded_images/Fortle.png": 89129,
	"./downloaded_images/Fortle_Cosmic.png": 8308,
	"./downloaded_images/Fortoise-menu.png": 94378,
	"./downloaded_images/Fortoise.png": 16312,
	"./downloaded_images/Fortoise_Cosmic.png": 3219,
	"./downloaded_images/Foxdra-menu.png": 91761,
	"./downloaded_images/Foxdra.png": 34785,
	"./downloaded_images/Foxdra_Cosmic.png": 15132,
	"./downloaded_images/Frail_Status_Icon.png": 13434,
	"./downloaded_images/Freeze_EX_SkillIcon.png": 45181,
	"./downloaded_images/Freeze_Status_Icon.png": 65453,
	"./downloaded_images/Frictingle-menu.png": 84608,
	"./downloaded_images/Frictingle.png": 58158,
	"./downloaded_images/Frictingle_Cosmic.png": 9937,
	"./downloaded_images/Fries.png": 69050,
	"./downloaded_images/Frogick-menu.png": 39892,
	"./downloaded_images/Frogick.png": 54930,
	"./downloaded_images/Frogick_Cosmic.png": 63493,
	"./downloaded_images/Frominence-menu.png": 58855,
	"./downloaded_images/Frominence.png": 13263,
	"./downloaded_images/Froppe2.png": 62961,
	"./downloaded_images/Froppe_(Extinction)-menu.png": 46200,
	"./downloaded_images/Frost_Bite_EX_SkillIcon.png": 32231,
	"./downloaded_images/Frosty_Winds_EX_SkillIcon.png": 80267,
	"./downloaded_images/Frozen_LakeWarp.png": 72669,
	"./downloaded_images/Frozen_Tundra_(Extinction)Warp.png": 695,
	"./downloaded_images/Fulmina-menu.png": 38191,
	"./downloaded_images/Fulmina.png": 65431,
	"./downloaded_images/Furious_Torrent_EX_SkillIcon.png": 87442,
	"./downloaded_images/Furrygon-menu.png": 53975,
	"./downloaded_images/Furrygon.png": 95359,
	"./downloaded_images/Gale_EX_SkillIcon.png": 23817,
	"./downloaded_images/Gekoko-menu.png": 71983,
	"./downloaded_images/Gekoko.png": 50967,
	"./downloaded_images/Gemaxar-menu.png": 27358,
	"./downloaded_images/Gemaxar.png": 40716,
	"./downloaded_images/Gemaxar_Cosmic.png": 47719,
	"./downloaded_images/Gemeen2.png": 48876,
	"./downloaded_images/Gemeen_(Extinction)-menu.png": 64239,
	"./downloaded_images/Gemock-menu.png": 49817,
	"./downloaded_images/Gemock.png": 777,
	"./downloaded_images/Gemock_Cosmic.png": 36980,
	"./downloaded_images/Ghost_Slash_EX_SkillIcon.png": 9155,
	"./downloaded_images/Ghost_Type_Icon.png": 13827,
	"./downloaded_images/Ghouze-menu.png": 64081,
	"./downloaded_images/Ghouze.png": 75329,
	"./downloaded_images/Ghouze_Cosmic.png": 92476,
	"./downloaded_images/Giddiyelp-menu.png": 26674,
	"./downloaded_images/Giddiyelp.png": 93856,
	"./downloaded_images/Giddiyelp_Cosmic.png": 48491,
	"./downloaded_images/Glamond-menu.png": 61939,
	"./downloaded_images/Glamond.png": 7019,
	"./downloaded_images/Glamoory-menu.png": 1701,
	"./downloaded_images/Glamoory.png": 42981,
	"./downloaded_images/Glamoory_Cosmic.png": 57120,
	"./downloaded_images/Glare_EX_SkillIcon.png": 1685,
	"./downloaded_images/Glaze_EX_SkillIcon.png": 25389,
	"./downloaded_images/Glazed-Cake.png": 26575,
	"./downloaded_images/Glidlee-menu.png": 57295,
	"./downloaded_images/Glidlee.png": 46839,
	"./downloaded_images/Glimoory-menu.png": 60461,
	"./downloaded_images/Glimoory.png": 59757,
	"./downloaded_images/Glimoory_Cosmic.png": 84728,
	"./downloaded_images/Globlob-menu.png": 12456,
	"./downloaded_images/Globlob.png": 84854,
	"./downloaded_images/Globlob_Cosmic.png": 85929,
	"./downloaded_images/Glontern-menu.png": 88182,
	"./downloaded_images/Glontern.png": 52196,
	"./downloaded_images/Glontern_Cosmic.png": 46255,
	"./downloaded_images/Glunch-menu.png": 4344,
	"./downloaded_images/Glunch.png": 96518,
	"./downloaded_images/Goateeze-menu.png": 64971,
	"./downloaded_images/Goateeze.png": 92675,
	"./downloaded_images/Goateeze_Cosmic.png": 18518,
	"./downloaded_images/Goatlanche-menu.png": 85051,
	"./downloaded_images/Goatlanche.png": 32051,
	"./downloaded_images/Goatlanche_Cosmic.png": 64998,
	"./downloaded_images/Goblat-menu.png": 24894,
	"./downloaded_images/Goblat.png": 5068,
	"./downloaded_images/Gomarm-menu.png": 50314,
	"./downloaded_images/Gomarm.png": 37048,
	"./downloaded_images/Gomarm_Cosmic.png": 91187,
	"./downloaded_images/Graciful-menu.png": 17744,
	"./downloaded_images/Graciful.png": 20702,
	"./downloaded_images/Graciful_Cosmic.png": 6145,
	"./downloaded_images/Gradow-menu.png": 7025,
	"./downloaded_images/Gradow.png": 70497,
	"./downloaded_images/Graloon-menu.png": 97635,
	"./downloaded_images/Graloon.png": 72187,
	"./downloaded_images/Grape.png": 29010,
	"./downloaded_images/Grasping_Root_EX_SkillIcon.png": 93648,
	"./downloaded_images/Grath-menu.png": 11331,
	"./downloaded_images/Grath.png": 79867,
	"./downloaded_images/Gravello-menu.png": 10821,
	"./downloaded_images/Gravello.png": 44965,
	"./downloaded_images/Gravello_Cosmic.png": 7840,
	"./downloaded_images/Grebal-menu.png": 41372,
	"./downloaded_images/Grebal.png": 9114,
	"./downloaded_images/Greben-menu.png": 24886,
	"./downloaded_images/Greben.png": 16164,
	"./downloaded_images/Green-Cake.png": 44073,
	"./downloaded_images/Green-Pear.png": 98273,
	"./downloaded_images/Green_Flow_EX_SkillIcon.png": 40854,
	"./downloaded_images/Green_Siphon_EX_SkillIcon.png": 97367,
	"./downloaded_images/Green_Sphere_EX_SkillIcon.png": 82203,
	"./downloaded_images/Green_Spirit_EX_SkillIcon.png": 18487,
	"./downloaded_images/Griff-menu.png": 77099,
	"./downloaded_images/Griff.png": 3683,
	"./downloaded_images/Griff_Cosmic.png": 69878,
	"./downloaded_images/Griffgar-menu.png": 98501,
	"./downloaded_images/Griffgar.png": 93605,
	"./downloaded_images/Griffgar_Cosmic.png": 96640,
	"./downloaded_images/Grimmon-menu.png": 4964,
	"./downloaded_images/Grimmon.png": 25666,
	"./downloaded_images/Grimmon_Cosmic.png": 10805,
	"./downloaded_images/Grunda2.png": 31728,
	"./downloaded_images/Grunda_(Extinction)-menu.png": 10475,
	"./downloaded_images/Guazharm-menu.png": 45842,
	"./downloaded_images/Guazharm.png": 96064,
	"./downloaded_images/Guazharm_Cosmic.png": 49611,
	"./downloaded_images/Gurgita-menu.png": 30390,
	"./downloaded_images/Gurgita.png": 12740,
	"./downloaded_images/Gust_EX_SkillIcon.png": 76849,
	"./downloaded_images/Gust_Wind_EX_SkillIcon.png": 43640,
	"./downloaded_images/Gusty_Storm_EX_SkillIcon.png": 96418,
	"./downloaded_images/HP_Stat_Icon.png": 33704,
	"./downloaded_images/Hainok-menu.png": 91813,
	"./downloaded_images/Hainok.png": 20485,
	"./downloaded_images/Harectic-menu.png": 31310,
	"./downloaded_images/Harectic.png": 30428,
	"./downloaded_images/Harectic_Cosmic.png": 89623,
	"./downloaded_images/Haunting_EX_SkillIcon.png": 7946,
	"./downloaded_images/Headbutt_EX_SkillIcon.png": 85721,
	"./downloaded_images/Heal_EX_SkillIcon.png": 75932,
	"./downloaded_images/Healing_Stone_EX_SkillIcon.png": 44042,
	"./downloaded_images/Healing_Water_EX_SkillIcon.png": 94676,
	"./downloaded_images/Heddeca-menu.png": 9677,
	"./downloaded_images/Heddeca.png": 87565,
	"./downloaded_images/Helipa-menu.png": 76996,
	"./downloaded_images/Helipa.png": 18274,
	"./downloaded_images/Helipa_Cosmic.png": 66389,
	"./downloaded_images/Heliventus-menu.png": 82496,
	"./downloaded_images/Heliventus.png": 22254,
	"./downloaded_images/Heliventus_Cosmic.png": 61681,
	"./downloaded_images/Heliwurm-menu.png": 38930,
	"./downloaded_images/Heliwurm.png": 79328,
	"./downloaded_images/Heliwurm_Cosmic.png": 37483,
	"./downloaded_images/Helovolk-menu.png": 74479,
	"./downloaded_images/Helovolk.png": 31255,
	"./downloaded_images/Hex_Status_Icon.png": 94251,
	"./downloaded_images/Hexia2.png": 12238,
	"./downloaded_images/Hexia_(Extinction)-menu.png": 75769,
	"./downloaded_images/Hidden_Village_(Extinction)Warp.png": 41823,
	"./downloaded_images/Hinazuru-menu.png": 2337,
	"./downloaded_images/Hinazuru.png": 29553,
	"./downloaded_images/Hinazuru_Cosmic.png": 52300,
	"./downloaded_images/Hoglet-menu.png": 21296,
	"./downloaded_images/Hoglet.png": 67646,
	"./downloaded_images/Hoglet_Cosmic.png": 40046,
	"./downloaded_images/Hohopi-menu.png": 95068,
	"./downloaded_images/Hohopi.png": 76410,
	"./downloaded_images/Hohopi_Cosmic.png": 22845,
	"./downloaded_images/Holoch-menu.png": 92336,
	"./downloaded_images/Holoch.png": 6014,
	"./downloaded_images/Holoch_Cosmic.png": 56225,
	"./downloaded_images/Horget-menu.png": 73856,
	"./downloaded_images/Horget.png": 8814,
	"./downloaded_images/Howling_Winds_EX_SkillIcon.png": 10088,
	"./downloaded_images/Hurristag2.png": 99592,
	"./downloaded_images/Hurristag_(Extinction)-menu.png": 54611,
	"./downloaded_images/Hydrip-menu.png": 51375,
	"./downloaded_images/Hydrip.png": 1431,
	"./downloaded_images/Hydrip_Cosmic.png": 41370,
	"./downloaded_images/Hydro_Sphere_EX_SkillIcon.png": 47992,
	"./downloaded_images/Hydrose-menu.png": 9729,
	"./downloaded_images/Hydrose.png": 31409,
	"./downloaded_images/Hydrose_Cosmic.png": 87052,
	"./downloaded_images/Hyphoon-menu.png": 1230,
	"./downloaded_images/Hyphoon.png": 44668,
	"./downloaded_images/Ice_Assault_EX_SkillIcon.png": 89993,
	"./downloaded_images/Ice_Flakes_EX_SkillIcon.png": 56264,
	"./downloaded_images/Icicle_EX_SkillIcon.png": 78629,
	"./downloaded_images/Ignigon-menu.png": 89688,
	"./downloaded_images/Ignigon.png": 64134,
	"./downloaded_images/Imburion-menu.png": 20700,
	"./downloaded_images/Imburion.png": 29242,
	"./downloaded_images/Imburion_Cosmic.png": 47645,
	"./downloaded_images/Imbuzi-menu.png": 97853,
	"./downloaded_images/Imbuzi.png": 99101,
	"./downloaded_images/Imbuzi_Cosmic.png": 90568,
	"./downloaded_images/Immortal_CitadelWarp.png": 58991,
	"./downloaded_images/Immortis-menu.png": 16011,
	"./downloaded_images/Immortis.png": 71747,
	"./downloaded_images/Inception_EX_SkillIcon.png": 72341,
	"./downloaded_images/Inception_Status_Icon.png": 34853,
	"./downloaded_images/Incinerate_EX_SkillIcon.png": 66594,
	"./downloaded_images/Infected_Seed_EX_SkillIcon.png": 72762,
	"./downloaded_images/Inominox-menu.png": 20484,
	"./downloaded_images/Inominox.png": 11394,
	"./downloaded_images/Invincible_EX_SkillIcon.png": 65211,
	"./downloaded_images/Jeeta2.png": 11325,
	"./downloaded_images/Jeeta_(Extinction)-menu.png": 26093,
	"./downloaded_images/Jeliflo-menu.png": 80886,
	"./downloaded_images/Jeliflo.png": 90852,
	"./downloaded_images/Jeliflo_Cosmic.png": 30063,
	"./downloaded_images/Jeliflux-menu.png": 4150,
	"./downloaded_images/Jeliflux.png": 7172,
	"./downloaded_images/Jeliflux_Cosmic.png": 99343,
	"./downloaded_images/Jeloon-menu.png": 6794,
	"./downloaded_images/Jeloon.png": 87736,
	"./downloaded_images/Jeloon_Cosmic.png": 68563,
	"./downloaded_images/Kamelevo-menu.png": 59353,
	"./downloaded_images/Kamelevo.png": 54889,
	"./downloaded_images/Kawsnow-menu.png": 13861,
	"./downloaded_images/Kawsnow.png": 29413,
	"./downloaded_images/Kawsnow_Cosmic.png": 29920,
	"./downloaded_images/Keromb-menu.png": 99279,
	"./downloaded_images/Keromb.png": 40311,
	"./downloaded_images/Keromb_Cosmic.png": 61978,
	"./downloaded_images/Kerosion-menu.png": 74541,
	"./downloaded_images/Kerosion.png": 12045,
	"./downloaded_images/Kerosion_Cosmic.png": 81176,
	"./downloaded_images/Kinetic_Mirror_EX_SkillIcon.png": 85789,
	"./downloaded_images/Kinetic_Sponge_EX_SkillIcon.png": 55532,
	"./downloaded_images/Kolphur-menu.png": 66078,
	"./downloaded_images/Kolphur.png": 32620,
	"./downloaded_images/Kolphur_Cosmic.png": 27527,
	"./downloaded_images/Krainnull-menu.png": 93093,
	"./downloaded_images/Krainnull.png": 75557,
	"./downloaded_images/Kroma-menu.png": 88311,
	"./downloaded_images/Kroma.png": 20799,
	"./downloaded_images/Kromatice2.png": 31638,
	"./downloaded_images/Kromatice_(Extinction)-menu.png": 33713,
	"./downloaded_images/Kromicide-menu.png": 2392,
	"./downloaded_images/Kromicide.png": 61158,
	"./downloaded_images/Kromicide_Cosmic.png": 82777,
	"./downloaded_images/Krowr2.png": 45270,
	"./downloaded_images/Krowr_(Extinction)-menu.png": 63729,
	"./downloaded_images/Lacreme.png": 19814,
	"./downloaded_images/Lamparos-menu.png": 5212,
	"./downloaded_images/Lamparos.png": 26106,
	"./downloaded_images/Lamparos_Cosmic.png": 1341,
	"./downloaded_images/Larkito-menu.png": 86893,
	"./downloaded_images/Larkito.png": 28749,
	"./downloaded_images/Larkito_Cosmic.png": 52600,
	"./downloaded_images/LateriaWarp.png": 54121,
	"./downloaded_images/Leaf_Dance_EX_SkillIcon.png": 40110,
	"./downloaded_images/Leech_Status_Icon.png": 94839,
	"./downloaded_images/Leechy-menu.png": 5899,
	"./downloaded_images/Leechy.png": 11363,
	"./downloaded_images/Leechy_Cosmic.png": 26422,
	"./downloaded_images/Lemon-Pie.png": 18371,
	"./downloaded_images/Lightning_Roar_EX_SkillIcon.png": 44277,
	"./downloaded_images/Lioness-menu.png": 69236,
	"./downloaded_images/Lioness.png": 25490,
	"./downloaded_images/Lioness_Cosmic.png": 19589,
	"./downloaded_images/Lock_Target_EX_SkillIcon.png": 23243,
	"./downloaded_images/Lovidovi-menu.png": 84515,
	"./downloaded_images/Lovidovi.png": 62459,
	"./downloaded_images/Lovinu-menu.png": 71258,
	"./downloaded_images/Lovinu.png": 21256,
	"./downloaded_images/Luhava2.png": 55680,
	"./downloaded_images/Luhava_(Extinction)-menu.png": 571,
	"./downloaded_images/Lukuma-menu.png": 95694,
	"./downloaded_images/Lukuma.png": 70332,
	"./downloaded_images/Lukuma_Cosmic.png": 41431,
	"./downloaded_images/Lumbi-menu.png": 60156,
	"./downloaded_images/Lumbi.png": 25434,
	"./downloaded_images/Lumbi_Cosmic.png": 2845,
	"./downloaded_images/Lume-menu.png": 48510,
	"./downloaded_images/Lume.png": 11756,
	"./downloaded_images/Lumefur-menu.png": 7389,
	"./downloaded_images/Lumefur.png": 87869,
	"./downloaded_images/Lumerei-menu.png": 11052,
	"./downloaded_images/Lumerei.png": 93194,
	"./downloaded_images/Lunabelle-menu.png": 12009,
	"./downloaded_images/Lunabelle.png": 48089,
	"./downloaded_images/Lurkennie-menu.png": 15710,
	"./downloaded_images/Lurkennie.png": 32524,
	"./downloaded_images/Lurkost-menu.png": 28933,
	"./downloaded_images/Lurkost.png": 14629,
	"./downloaded_images/Luxa2.png": 53161,
	"./downloaded_images/Luxa_(Extinction)-menu.png": 97504,
	"./downloaded_images/Lycopain2.png": 59528,
	"./downloaded_images/Lycopain_(Extinction)-menu.png": 40467,
	"./downloaded_images/Madamusa-menu.png": 40340,
	"./downloaded_images/Madamusa.png": 62994,
	"./downloaded_images/Madamusa_Cosmic.png": 42757,
	"./downloaded_images/Magnipub-menu.png": 4542,
	"./downloaded_images/Magnipub.png": 38636,
	"./downloaded_images/Magnipub_Cosmic.png": 89703,
	"./downloaded_images/Malenostra-menu.png": 95015,
	"./downloaded_images/Malenostra.png": 2959,
	"./downloaded_images/Malenostra_Cosmic.png": 93858,
	"./downloaded_images/Malevodo-menu.png": 9488,
	"./downloaded_images/Malevodo.png": 73118,
	"./downloaded_images/Malevodo_Cosmic.png": 69409,
	"./downloaded_images/Malitress-menu.png": 5407,
	"./downloaded_images/Malitress.png": 75911,
	"./downloaded_images/Malitress_Cosmic.png": 35402,
	"./downloaded_images/Mallark-menu.png": 55305,
	"./downloaded_images/Mallark.png": 86457,
	"./downloaded_images/Mallark_Cosmic.png": 51044,
	"./downloaded_images/Mallish-menu.png": 24917,
	"./downloaded_images/Mallish.png": 45717,
	"./downloaded_images/Mallish_Cosmic.png": 2640,
	"./downloaded_images/Mandrass2.png": 60714,
	"./downloaded_images/Mandrass_(Extinction)-menu.png": 79277,
	"./downloaded_images/Mantoo-menu.png": 24137,
	"./downloaded_images/Mantoo.png": 52633,
	"./downloaded_images/Mantoo_Cosmic.png": 4836,
	"./downloaded_images/Mantrass-menu.png": 1076,
	"./downloaded_images/Mantrass.png": 32498,
	"./downloaded_images/Mantrass_Cosmic.png": 73317,
	"./downloaded_images/Mara-menu.png": 86036,
	"./downloaded_images/Mara.png": 84530,
	"./downloaded_images/Marasuma-menu.png": 33694,
	"./downloaded_images/Marasuma.png": 10156,
	"./downloaded_images/Maraudin-menu.png": 92126,
	"./downloaded_images/Maraudin.png": 80908,
	"./downloaded_images/Martial_Arts_EX_SkillIcon.png": 78111,
	"./downloaded_images/Masqat-menu.png": 7404,
	"./downloaded_images/Masqat.png": 78442,
	"./downloaded_images/Masquiti-menu.png": 28640,
	"./downloaded_images/Masquiti.png": 71694,
	"./downloaded_images/Mazecter-menu.png": 23816,
	"./downloaded_images/Mazecter.png": 32054,
	"./downloaded_images/Mazecter_Cosmic.png": 6505,
	"./downloaded_images/Mearn-menu.png": 52738,
	"./downloaded_images/Mearn.png": 38672,
	"./downloaded_images/Meat.png": 4370,
	"./downloaded_images/Medlass-menu.png": 70188,
	"./downloaded_images/Medlass.png": 17706,
	"./downloaded_images/Medlass_Cosmic.png": 33389,
	"./downloaded_images/Mermella-menu.png": 3306,
	"./downloaded_images/Mermella.png": 72504,
	"./downloaded_images/Meteor_Shower_EX_SkillIcon.png": 19189,
	"./downloaded_images/Meteor_Strike_EX_SkillIcon.png": 25825,
	"./downloaded_images/Mimi-menu.png": 62831,
	"./downloaded_images/Mimi.png": 29079,
	"./downloaded_images/Mimi_Cosmic.png": 69210,
	"./downloaded_images/Mimorus-menu.png": 87235,
	"./downloaded_images/Mimorus.png": 72411,
	"./downloaded_images/Mimorus_Cosmic.png": 71102,
	"./downloaded_images/Mind_Control_EX_SkillIcon.png": 79496,
	"./downloaded_images/Mind_Shake_EX_SkillIcon.png": 73223,
	"./downloaded_images/Mineral_Siphon_EX_SkillIcon.png": 62104,
	"./downloaded_images/Mineral_Type_Icon.png": 12044,
	"./downloaded_images/Minet-menu.png": 73670,
	"./downloaded_images/Minet.png": 94420,
	"./downloaded_images/Minet_Cosmic.png": 84607,
	"./downloaded_images/Minetor-menu.png": 31575,
	"./downloaded_images/Minetor.png": 58591,
	"./downloaded_images/Minetor_Cosmic.png": 82258,
	"./downloaded_images/Mirage_EX_SkillIcon.png": 84925,
	"./downloaded_images/Mistralion2.png": 45143,
	"./downloaded_images/Mistralion_(Extinction)-menu.png": 58894,
	"./downloaded_images/Moga-menu.png": 10983,
	"./downloaded_images/Moga.png": 24367,
	"./downloaded_images/Moga_Cosmic.png": 88322,
	"./downloaded_images/Mojompu-menu.png": 30154,
	"./downloaded_images/Mojompu.png": 47864,
	"./downloaded_images/Mojompu_Cosmic.png": 44307,
	"./downloaded_images/Moltano-menu.png": 60195,
	"./downloaded_images/Moltano.png": 49659,
	"./downloaded_images/Moltano_Cosmic.png": 99678,
	"./downloaded_images/Monkapow.png": 69283,
	"./downloaded_images/Monkapow2.png": 23257,
	"./downloaded_images/Monkapow2_Cosmic.png": 23812,
	"./downloaded_images/Monkapow_(Extinction)-menu.png": 7888,
	"./downloaded_images/Moonette-menu.png": 4796,
	"./downloaded_images/Moonette.png": 33082,
	"./downloaded_images/Moonica-menu.png": 34899,
	"./downloaded_images/Moonica.png": 61707,
	"./downloaded_images/Moonline-menu.png": 24476,
	"./downloaded_images/Moonline.png": 97850,
	"./downloaded_images/Moonline_Cosmic.png": 63293,
	"./downloaded_images/Moonsting-menu.png": 6693,
	"./downloaded_images/Moonsting.png": 76005,
	"./downloaded_images/Moonsting_Cosmic.png": 37184,
	"./downloaded_images/Moska-menu.png": 52358,
	"./downloaded_images/Moska.png": 44116,
	"./downloaded_images/Moska_Cosmic.png": 46655,
	"./downloaded_images/Mound-menu.png": 2078,
	"./downloaded_images/Mound.png": 88812,
	"./downloaded_images/Mound_Cosmic.png": 4359,
	"./downloaded_images/Mud_Attack_EX_SkillIcon.png": 25237,
	"./downloaded_images/Mulcimer-menu.png": 33369,
	"./downloaded_images/Mulcimer.png": 12374,
	"./downloaded_images/Muu-menu.png": 54234,
	"./downloaded_images/Muu.png": 77768,
	"./downloaded_images/Mystic_Aroma_EX_SkillIcon.png": 21906,
	"./downloaded_images/Mystogen-menu.png": 53695,
	"./downloaded_images/Mystogen.png": 97735,
	"./downloaded_images/Nakazuru-menu.png": 19186,
	"./downloaded_images/Nakazuru.png": 61600,
	"./downloaded_images/Nakazuru_Cosmic.png": 45771,
	"./downloaded_images/Namansi-menu.png": 41156,
	"./downloaded_images/Namansi.png": 12674,
	"./downloaded_images/Nara2.png": 65049,
	"./downloaded_images/Nara_(Extinction)-menu.png": 88720,
	"./downloaded_images/Natural_Heal_EX_SkillIcon.png": 73313,
	"./downloaded_images/Navrigal-menu.png": 35255,
	"./downloaded_images/Navrigal.png": 97119,
	"./downloaded_images/Navrigal_Cosmic.png": 1490,
	"./downloaded_images/Neglente-menu.png": 29053,
	"./downloaded_images/Neglente.png": 21021,
	"./downloaded_images/Neglente_Cosmic.png": 72552,
	"./downloaded_images/Nekgiri-menu.png": 4404,
	"./downloaded_images/Nekgiri.png": 59954,
	"./downloaded_images/Nekpanchi-menu.png": 6906,
	"./downloaded_images/Nekpanchi.png": 33928,
	"./downloaded_images/Nervous_Status_Icon.png": 52654,
	"./downloaded_images/New_IgnitiaWarp.png": 31649,
	"./downloaded_images/Ninstuff-menu.png": 63918,
	"./downloaded_images/Ninstuff.png": 31836,
	"./downloaded_images/Ninstuff_Cosmic.png": 53623,
	"./downloaded_images/Nivalis-menu.png": 35211,
	"./downloaded_images/Nivalis.png": 52419,
	"./downloaded_images/Noki-menu.png": 52280,
	"./downloaded_images/Noki.png": 32774,
	"./downloaded_images/Noocidal-menu.png": 12938,
	"./downloaded_images/Noocidal.png": 72984,
	"./downloaded_images/Normal_Type_Icon.png": 35927,
	"./downloaded_images/Ocean_Force_EX_SkillIcon.png": 9856,
	"./downloaded_images/Octollect-menu.png": 95082,
	"./downloaded_images/Octollect.png": 5656,
	"./downloaded_images/Octollect_Cosmic.png": 55155,
	"./downloaded_images/Odiborg-menu.png": 72981,
	"./downloaded_images/Odiborg.png": 38069,
	"./downloaded_images/Odiborg_Cosmic.png": 17968,
	"./downloaded_images/Ogoon2.png": 38719,
	"./downloaded_images/Ogoon_(Extinction)-menu.png": 76262,
	"./downloaded_images/Omecharge-menu.png": 15464,
	"./downloaded_images/Omecharge.png": 19734,
	"./downloaded_images/Omelette.png": 34834,
	"./downloaded_images/Omentic-menu.png": 73510,
	"./downloaded_images/Omentic.png": 96404,
	"./downloaded_images/Omepark-menu.png": 19652,
	"./downloaded_images/Omepark.png": 57154,
	"./downloaded_images/Omnisun-menu.png": 87950,
	"./downloaded_images/Omnisun.png": 23900,
	"./downloaded_images/Onigiri.png": 76608,
	"./downloaded_images/Onin-menu.png": 80237,
	"./downloaded_images/Onin.png": 7981,
	"./downloaded_images/Onin_Cosmic.png": 10968,
	"./downloaded_images/Orange.png": 51861,
	"./downloaded_images/Oregoon-menu.png": 64336,
	"./downloaded_images/Oregoon.png": 19582,
	"./downloaded_images/Oren-menu.png": 86181,
	"./downloaded_images/Oren.png": 9349,
	"./downloaded_images/Orgot-menu.png": 86510,
	"./downloaded_images/Orgot.png": 62972,
	"./downloaded_images/Orologikus-menu.png": 72243,
	"./downloaded_images/Orologikus.png": 28139,
	"./downloaded_images/Orologikus_Cosmic.png": 86254,
	"./downloaded_images/Ostrolt-menu.png": 99694,
	"./downloaded_images/Ostrolt.png": 93084,
	"./downloaded_images/Ostrolt_Cosmic.png": 12695,
	"./downloaded_images/Outgrov-menu.png": 83127,
	"./downloaded_images/Outgrov.png": 50655,
	"./downloaded_images/Outgrov_Cosmic.png": 7666,
	"./downloaded_images/Palm_Flurry_EX_SkillIcon.png": 66395,
	"./downloaded_images/PalmayaWarp.png": 76926,
	"./downloaded_images/Palsae-menu.png": 81111,
	"./downloaded_images/Palsae.png": 12831,
	"./downloaded_images/Pandulce.png": 91783,
	"./downloaded_images/Paralyze_Status_Icon.png": 95080,
	"./downloaded_images/Parchidna-menu.png": 81635,
	"./downloaded_images/Parchidna.png": 71579,
	"./downloaded_images/Parchidna_Cosmic.png": 13086,
	"./downloaded_images/Parum_CityWarp.png": 2946,
	"./downloaded_images/Paupo-menu.png": 6060,
	"./downloaded_images/Paupo.png": 69354,
	"./downloaded_images/Peach.png": 32952,
	"./downloaded_images/Pebglem-menu.png": 87973,
	"./downloaded_images/Pebglem.png": 61989,
	"./downloaded_images/Pebglem_Cosmic.png": 70880,
	"./downloaded_images/Peltry-menu.png": 90741,
	"./downloaded_images/Peltry.png": 35765,
	"./downloaded_images/Peltry_Cosmic.png": 46832,
	"./downloaded_images/Pendulum_EX_SkillIcon.png": 58964,
	"./downloaded_images/Petram-menu.png": 93504,
	"./downloaded_images/Petram.png": 4974,
	"./downloaded_images/Phantom_Abyss_EX_SkillIcon.png": 97452,
	"./downloaded_images/Phantom_Blast_EX_SkillIcon.png": 63254,
	"./downloaded_images/Phantom_Burner_EX_SkillIcon.png": 36958,
	"./downloaded_images/Phantra-menu.png": 34859,
	"./downloaded_images/Phantra.png": 81251,
	"./downloaded_images/Piercing_Root_EX_SkillIcon.png": 53786,
	"./downloaded_images/Pincho.png": 6720,
	"./downloaded_images/Pink-Pecana.png": 48956,
	"./downloaded_images/Plant_Type_Icon.png": 69421,
	"./downloaded_images/Planted_Status_Icon.png": 82820,
	"./downloaded_images/Plasma_Cannon_EX_SkillIcon.png": 93096,
	"./downloaded_images/Plasma_EX_SkillIcon.png": 74208,
	"./downloaded_images/Plasma_Star_EX_SkillIcon.png": 24633,
	"./downloaded_images/Ploriol-menu.png": 46212,
	"./downloaded_images/Ploriol.png": 72706,
	"./downloaded_images/Ploriol_Cosmic.png": 25205,
	"./downloaded_images/Pluvean-menu.png": 20458,
	"./downloaded_images/Pluvean.png": 8312,
	"./downloaded_images/Poison_Bubbles_EX_SkillIcon.png": 13278,
	"./downloaded_images/Poison_Cloud_EX_SkillIcon.png": 95664,
	"./downloaded_images/Poison_Status_Icon.png": 8352,
	"./downloaded_images/Poison_Sting_EX_SkillIcon.png": 54344,
	"./downloaded_images/Pongo-menu.png": 48944,
	"./downloaded_images/Pongo.png": 1950,
	"./downloaded_images/Pongo_Cosmic.png": 77761,
	"./downloaded_images/Ponic-menu.png": 41522,
	"./downloaded_images/Ponic.png": 96768,
	"./downloaded_images/Ponic_Cosmic.png": 37963,
	"./downloaded_images/Pont-menu.png": 35768,
	"./downloaded_images/Pont.png": 15846,
	"./downloaded_images/Pont_Cosmic.png": 7385,
	"./downloaded_images/Porklet-menu.png": 23180,
	"./downloaded_images/Porklet.png": 40906,
	"./downloaded_images/Porklet_Cosmic.png": 37101,
	"./downloaded_images/Potpot-menu.png": 12005,
	"./downloaded_images/Potpot.png": 47365,
	"./downloaded_images/Potpot_Cosmic.png": 32736,
	"./downloaded_images/Power_Up_EX_SkillIcon.png": 83209,
	"./downloaded_images/Poyal-menu.png": 66810,
	"./downloaded_images/Poyal.png": 96552,
	"./downloaded_images/Poyal_Cosmic.png": 59555,
	"./downloaded_images/Prankrow-menu.png": 98325,
	"./downloaded_images/Prankrow.png": 6101,
	"./downloaded_images/Prankrow_Cosmic.png": 51440,
	"./downloaded_images/Precursor_MountainWarp.png": 74904,
	"./downloaded_images/Prismazor2.png": 70494,
	"./downloaded_images/Prismazor_(Extinction)-menu.png": 69737,
	"./downloaded_images/Protovados-menu.png": 42688,
	"./downloaded_images/Protovados.png": 29582,
	"./downloaded_images/Provoked_Status_Icon.png": 1336,
	"./downloaded_images/Psy_Blast_EX_SkillIcon.png": 76011,
	"./downloaded_images/Psy_Bomb_EX_SkillIcon.png": 20699,
	"./downloaded_images/Psy_Burst_EX_SkillIcon.png": 5395,
	"./downloaded_images/Psy_Field_EX_SkillIcon.png": 78881,
	"./downloaded_images/Psy_Geyser_EX_SkillIcon.png": 35116,
	"./downloaded_images/Psy_Ray_EX_SkillIcon.png": 69145,
	"./downloaded_images/Psychic_Armor_EX_SkillIcon.png": 23489,
	"./downloaded_images/Psychic_Barrage_EX_SkillIcon.png": 37606,
	"./downloaded_images/Psychic_Blast_EX_SkillIcon.png": 20420,
	"./downloaded_images/Psychic_Bomb_EX_SkillIcon.png": 16130,
	"./downloaded_images/Psychic_Siphon_EX_SkillIcon.png": 92555,
	"./downloaded_images/Psychic_Type_Icon.png": 8883,
	"./downloaded_images/Puggard-menu.png": 76757,
	"./downloaded_images/Puggard.png": 10069,
	"./downloaded_images/Puggard_Cosmic.png": 14128,
	"./downloaded_images/Pulse_Storm_EX_SkillIcon.png": 98613,
	"./downloaded_images/Pummel_EX_SkillIcon.png": 52250,
	"./downloaded_images/Puzzled_Status_Icon.png": 20680,
	"./downloaded_images/Pyro_Bomb_EX_SkillIcon.png": 58295,
	"./downloaded_images/Quarauga-menu.png": 52396,
	"./downloaded_images/Quarauga.png": 53386,
	"./downloaded_images/Quarauga_Cosmic.png": 31213,
	"./downloaded_images/Quarmor-menu.png": 9258,
	"./downloaded_images/Quarmor.png": 81880,
	"./downloaded_images/Quarmor_Cosmic.png": 47763,
	"./downloaded_images/Quick_Feet_EX_SkillIcon.png": 36486,
	"./downloaded_images/Raamu2.png": 84163,
	"./downloaded_images/Raamu_(Extinction)-menu.png": 21122,
	"./downloaded_images/Raging_Focus_EX_SkillIcon.png": 41859,
	"./downloaded_images/Raksuma-menu.png": 45247,
	"./downloaded_images/Raksuma.png": 92839,
	"./downloaded_images/Rapi-menu.png": 77197,
	"./downloaded_images/Rapi.png": 5613,
	"./downloaded_images/Rapi_Cosmic.png": 93336,
	"./downloaded_images/Rapilux-menu.png": 71408,
	"./downloaded_images/Rapilux.png": 17214,
	"./downloaded_images/Rapilux_Cosmic.png": 70785,
	"./downloaded_images/Rapnux-menu.png": 51481,
	"./downloaded_images/Rapnux.png": 89609,
	"./downloaded_images/Rappub-menu.png": 33009,
	"./downloaded_images/Rappub.png": 38081,
	"./downloaded_images/Rappub_Cosmic.png": 90780,
	"./downloaded_images/Recover_EX_SkillIcon.png": 158,
	"./downloaded_images/Recover_Status_Icon.png": 84084,
	"./downloaded_images/Reeferus-menu.png": 51190,
	"./downloaded_images/Reeferus.png": 66980,
	"./downloaded_images/Reflective_Mirror_EX_SkillIcon.png": 58007,
	"./downloaded_images/Renovate_EX_SkillIcon.png": 35738,
	"./downloaded_images/Reptomotor-menu.png": 52344,
	"./downloaded_images/Reptomotor.png": 29574,
	"./downloaded_images/Resistance_EX_SkillIcon.png": 8399,
	"./downloaded_images/Resonating_Rock_EX_SkillIcon.png": 47012,
	"./downloaded_images/Resonect2.png": 68392,
	"./downloaded_images/Resonect_(Extinction)-menu.png": 68467,
	"./downloaded_images/Resonic-menu.png": 56580,
	"./downloaded_images/Resonic.png": 49826,
	"./downloaded_images/Ribombo-menu.png": 25405,
	"./downloaded_images/Ribombo.png": 67837,
	"./downloaded_images/Ribombo_Cosmic.png": 61352,
	"./downloaded_images/Ripha-menu.png": 78007,
	"./downloaded_images/Ripha.png": 99231,
	"./downloaded_images/Ripha_Cosmic.png": 10578,
	"./downloaded_images/Rock_Barrage_EX_SkillIcon.png": 16964,
	"./downloaded_images/Rock_Prison_EX_SkillIcon.png": 62111,
	"./downloaded_images/Rock_Punch_EX_SkillIcon.png": 8256,
	"./downloaded_images/Rock_Wall_EX_SkillIcon.png": 67420,
	"./downloaded_images/Rocknite_Blast_EX_SkillIcon.png": 2260,
	"./downloaded_images/Rocknite_Burst_EX_SkillIcon.png": 72960,
	"./downloaded_images/Rocknite_EX_SkillIcon.png": 8145,
	"./downloaded_images/Rocky_Rift_EX_SkillIcon.png": 60384,
	"./downloaded_images/Roclas-menu.png": 53287,
	"./downloaded_images/Roclas.png": 86191,
	"./downloaded_images/Roclas_Cosmic.png": 92258,
	"./downloaded_images/Rotramus-menu.png": 94292,
	"./downloaded_images/Rotramus.png": 62706,
	"./downloaded_images/Rubby-menu.png": 23179,
	"./downloaded_images/Rubby.png": 65283,
	"./downloaded_images/Rubby_Cosmic.png": 32118,
	"./downloaded_images/Runk-menu.png": 86901,
	"./downloaded_images/Runk.png": 77589,
	"./downloaded_images/Runk_Cosmic.png": 15440,
	"./downloaded_images/Rust-menu.png": 39961,
	"./downloaded_images/Rust.png": 18793,
	"./downloaded_images/Rust_Cosmic.png": 16628,
	"./downloaded_images/Rustu-menu.png": 56850,
	"./downloaded_images/Rustu.png": 37888,
	"./downloaded_images/Rustu_Cosmic.png": 70955,
	"./downloaded_images/Rustung-menu.png": 62121,
	"./downloaded_images/Rustung.png": 1113,
	"./downloaded_images/Rustung_Cosmic.png": 44740,
	"./downloaded_images/Sacred_Mineral_EX_SkillIcon.png": 35307,
	"./downloaded_images/Sae-menu.png": 87680,
	"./downloaded_images/Sae.png": 29070,
	"./downloaded_images/Sakka-menu.png": 95630,
	"./downloaded_images/Sakka.png": 90332,
	"./downloaded_images/Sakka_Cosmic.png": 10071,
	"./downloaded_images/Sandillo-menu.png": 42669,
	"./downloaded_images/Sandillo.png": 11565,
	"./downloaded_images/Sandillo_Cosmic.png": 22584,
	"./downloaded_images/Sandstorm_EX_SkillIcon.png": 86925,
	"./downloaded_images/Sausage.png": 78038,
	"./downloaded_images/Scailla-menu.png": 51600,
	"./downloaded_images/Scailla.png": 70206,
	"./downloaded_images/Scailla_Cosmic.png": 55169,
	"./downloaded_images/Scalder-menu.png": 24257,
	"./downloaded_images/Scalder.png": 42833,
	"./downloaded_images/Scalder_Cosmic.png": 77356,
	"./downloaded_images/Scaratic-menu.png": 38587,
	"./downloaded_images/Scaratic.png": 60339,
	"./downloaded_images/Scaratic_Cosmic.png": 95142,
	"./downloaded_images/Scooptor-menu.png": 6086,
	"./downloaded_images/Scooptor.png": 43796,
	"./downloaded_images/Scooptor_Cosmic.png": 62463,
	"./downloaded_images/Scratch_EX_SkillIcon.png": 90924,
	"./downloaded_images/Screech_EX_SkillIcon.png": 9667,
	"./downloaded_images/Sectoc-menu.png": 38894,
	"./downloaded_images/Sectoc.png": 39932,
	"./downloaded_images/Sectoc_Cosmic.png": 30391,
	"./downloaded_images/Seedko-menu.png": 30184,
	"./downloaded_images/Seedko.png": 80534,
	"./downloaded_images/Seedko_Cosmic.png": 88617,
	"./downloaded_images/Seedkorsky-menu.png": 89535,
	"./downloaded_images/Seedkorsky.png": 97095,
	"./downloaded_images/Seedkorsky_Cosmic.png": 77450,
	"./downloaded_images/Seismic_Move_EX_SkillIcon.png": 19255,
	"./downloaded_images/Senshizuru-menu.png": 27371,
	"./downloaded_images/Senshizuru.png": 80707,
	"./downloaded_images/Senshizuru_Cosmic.png": 35286,
	"./downloaded_images/Shardberg-menu.png": 55909,
	"./downloaded_images/Shardberg.png": 21253,
	"./downloaded_images/Shardberg_Cosmic.png": 55232,
	"./downloaded_images/Shardice-menu.png": 1240,
	"./downloaded_images/Shardice.png": 43430,
	"./downloaded_images/Shardice_Cosmic.png": 56697,
	"./downloaded_images/Shardrillion-menu.png": 30726,
	"./downloaded_images/Shardrillion.png": 71444,
	"./downloaded_images/Shardrillion_Cosmic.png": 17087,
	"./downloaded_images/Shardrine-menu.png": 46743,
	"./downloaded_images/Shardrine.png": 55743,
	"./downloaded_images/Shardrine_Cosmic.png": 21458,
	"./downloaded_images/Shloom-menu.png": 27661,
	"./downloaded_images/Shloom.png": 75021,
	"./downloaded_images/Shloom_Cosmic.png": 75160,
	"./downloaded_images/Short_Circuit_EX_SkillIcon.png": 94232,
	"./downloaded_images/Shrimpgiri.png": 28477,
	"./downloaded_images/Shromboff-menu.png": 66739,
	"./downloaded_images/Shromboff.png": 95435,
	"./downloaded_images/Shromboff_Cosmic.png": 77390,
	"./downloaded_images/Shrombrela-menu.png": 21642,
	"./downloaded_images/Shrombrela.png": 9560,
	"./downloaded_images/Shrombrela_Cosmic.png": 99123,
	"./downloaded_images/Shromporo-menu.png": 96062,
	"./downloaded_images/Shromporo.png": 96876,
	"./downloaded_images/Shromporo_Cosmic.png": 40967,
	"./downloaded_images/Sick_Status_Icon.png": 92706,
	"./downloaded_images/Siki-menu.png": 21507,
	"./downloaded_images/Siki.png": 13467,
	"./downloaded_images/Sikihob-menu.png": 72654,
	"./downloaded_images/Sikihob.png": 30556,
	"./downloaded_images/Sikipha-menu.png": 57796,
	"./downloaded_images/Sikipha.png": 53090,
	"./downloaded_images/Singlette-menu.png": 89420,
	"./downloaded_images/Singlette.png": 21309,
	"./downloaded_images/Singlette_Cosmic.png": 35149,
	"./downloaded_images/Singletti-menu.png": 7640,
	"./downloaded_images/Singletti.png": 52870,
	"./downloaded_images/Singletti_Cosmic.png": 56249,
	"./downloaded_images/Siphon_EX_SkillIcon.png": 86043,
	"./downloaded_images/Sirnymfa-menu.png": 45824,
	"./downloaded_images/Sirnymfa.png": 57422,
	"./downloaded_images/Skerdi-menu.png": 36909,
	"./downloaded_images/Skerdi.png": 45709,
	"./downloaded_images/Skerdi_Cosmic.png": 28184,
	"./downloaded_images/Skounquet-menu.png": 86648,
	"./downloaded_images/Skounquet.png": 97286,
	"./downloaded_images/Skounquet_Cosmic.png": 25753,
	"./downloaded_images/Skunqeau-menu.png": 72482,
	"./downloaded_images/Skunqeau.png": 10352,
	"./downloaded_images/Skunqeau_Cosmic.png": 63355,
	"./downloaded_images/Skunqute-menu.png": 35275,
	"./downloaded_images/Skunqute.png": 89411,
	"./downloaded_images/Skunqute_Cosmic.png": 80022,
	"./downloaded_images/Sky_Blessing_EX_SkillIcon.png": 11845,
	"./downloaded_images/Slashing_Current_EX_SkillIcon.png": 56839,
	"./downloaded_images/Sleep_Song_EX_SkillIcon.png": 5927,
	"./downloaded_images/Sleep_Status_Icon.png": 77205,
	"./downloaded_images/Smanic-menu.png": 89064,
	"./downloaded_images/Smanic.png": 52054,
	"./downloaded_images/Smoke_Screen_EX_SkillIcon.png": 43608,
	"./downloaded_images/Snaibble-menu.png": 31511,
	"./downloaded_images/Snaibble.png": 6239,
	"./downloaded_images/Snaibble_Cosmic.png": 25202,
	"./downloaded_images/Snaiflow-menu.png": 6540,
	"./downloaded_images/Snaiflow.png": 33226,
	"./downloaded_images/Snaiflow_Cosmic.png": 8045,
	"./downloaded_images/Snaijet-menu.png": 74089,
	"./downloaded_images/Snaijet.png": 84121,
	"./downloaded_images/Snaijet_Cosmic.png": 50724,
	"./downloaded_images/Snake_Eyes_EX_SkillIcon.png": 53405,
	"./downloaded_images/Snush-menu.png": 87524,
	"./downloaded_images/Snush.png": 19202,
	"./downloaded_images/Snush_Cosmic.png": 86869,
	"./downloaded_images/Solar_Charge_EX_SkillIcon.png": 15948,
	"./downloaded_images/Solar_Flare_EX_SkillIcon.png": 24444,
	"./downloaded_images/Solus-menu.png": 62725,
	"./downloaded_images/Solus.png": 52485,
	"./downloaded_images/Sonic_Scream_EX_SkillIcon.png": 3482,
	"./downloaded_images/Soniqo-menu.png": 8360,
	"./downloaded_images/Soniqo.png": 22134,
	"./downloaded_images/Soniqo_Cosmic.png": 99689,
	"./downloaded_images/Sorvian-menu.png": 71493,
	"./downloaded_images/Sorvian.png": 59237,
	"./downloaded_images/Soul_Feeder_EX_SkillIcon.png": 66625,
	"./downloaded_images/Sounse-menu.png": 25498,
	"./downloaded_images/Sounse.png": 45352,
	"./downloaded_images/Sounse_Cosmic.png": 25219,
	"./downloaded_images/Spectral_Invasion_EX_SkillIcon.png": 22472,
	"./downloaded_images/Spectral_Wall_EX_SkillIcon.png": 96319,
	"./downloaded_images/Speed_Stat_Icon.png": 17837,
	"./downloaded_images/Spektar-menu.png": 24845,
	"./downloaded_images/Spektar.png": 69133,
	"./downloaded_images/Spikarm-menu.png": 84720,
	"./downloaded_images/Spikarm.png": 52478,
	"./downloaded_images/Spikarm_Cosmic.png": 64769,
	"./downloaded_images/Spikus-menu.png": 37072,
	"./downloaded_images/Spikus.png": 48574,
	"./downloaded_images/Spikus_Cosmic.png": 78017,
	"./downloaded_images/Spinning_Kick_EX_SkillIcon.png": 47243,
	"./downloaded_images/Spiritual_Boost_EX_SkillIcon.png": 58179,
	"./downloaded_images/Splash_EX_SkillIcon.png": 87257,
	"./downloaded_images/Stalagca-menu.png": 50313,
	"./downloaded_images/Stalagca.png": 24665,
	"./downloaded_images/Stalagca_Cosmic.png": 60439,
	"./downloaded_images/Stalkee-menu.png": 14302,
	"./downloaded_images/Stalkee.png": 73676,
	"./downloaded_images/Stalkee_Cosmic.png": 65767,
	"./downloaded_images/Stamina_Stat_Icon.png": 84191,
	"./downloaded_images/Stamina_Surge_EX_SkillIcon.png": 56830,
	"./downloaded_images/Starckal-menu.png": 18820,
	"./downloaded_images/Starckal.png": 89602,
	"./downloaded_images/Starckal_Cosmic.png": 58421,
	"./downloaded_images/Static_Burst_EX_SkillIcon.png": 80569,
	"./downloaded_images/Stinger-menu.png": 66813,
	"./downloaded_images/Stinger.png": 57533,
	"./downloaded_images/Stinger_Cosmic.png": 71656,
	"./downloaded_images/Strawberry-Cake.png": 60739,
	"./downloaded_images/Streamoad-menu.png": 90363,
	"./downloaded_images/Streamoad.png": 76563,
	"./downloaded_images/Streamoad_Cosmic.png": 58406,
	"./downloaded_images/Streamog-menu.png": 96161,
	"./downloaded_images/Streamog.png": 84817,
	"./downloaded_images/Streamog_Cosmic.png": 1804,
	"./downloaded_images/Streamole-menu.png": 17861,
	"./downloaded_images/Streamole.png": 84677,
	"./downloaded_images/Streamole_Cosmic.png": 75296,
	"./downloaded_images/Sulphlo-menu.png": 13002,
	"./downloaded_images/Sulphlo.png": 80088,
	"./downloaded_images/Sulphlo_Cosmic.png": 75091,
	"./downloaded_images/Suncore_EX_SkillIcon.png": 69139,
	"./downloaded_images/Sunknight-menu.png": 55776,
	"./downloaded_images/Sunknight.png": 10574,
	"./downloaded_images/Sunknight_Cosmic.png": 70257,
	"./downloaded_images/Sunnos-menu.png": 43477,
	"./downloaded_images/Sunnos.png": 43605,
	"./downloaded_images/Sunnos_Cosmic.png": 26416,
	"./downloaded_images/Sunshine_EX_SkillIcon.png": 58403,
	"./downloaded_images/Super_Charge_EX_SkillIcon.png": 3298,
	"./downloaded_images/Super_Punch_EX_SkillIcon.png": 8590,
	"./downloaded_images/Super_Slam_EX_SkillIcon.png": 49891,
	"./downloaded_images/Survive_Status_Icon.png": 37062,
	"./downloaded_images/Swactrum-menu.png": 71533,
	"./downloaded_images/Swactrum.png": 40013,
	"./downloaded_images/Swactrum_Cosmic.png": 19608,
	"./downloaded_images/Swamplow-menu.png": 60273,
	"./downloaded_images/Swamplow.png": 70721,
	"./downloaded_images/Swamplow_Cosmic.png": 45756,
	"./downloaded_images/Tackle_EX_SkillIcon.png": 47476,
	"./downloaded_images/Taco.png": 6632,
	"./downloaded_images/Taipluff-menu.png": 44554,
	"./downloaded_images/Taipluff.png": 58584,
	"./downloaded_images/Taipluff_Cosmic.png": 68723,
	"./downloaded_images/Tantrunt-menu.png": 9981,
	"./downloaded_images/Tantrunt.png": 52925,
	"./downloaded_images/Tarragon-menu.png": 81733,
	"./downloaded_images/Tarragon.png": 3237,
	"./downloaded_images/Telepathy_EX_SkillIcon.png": 9468,
	"./downloaded_images/Tephragon2.png": 78791,
	"./downloaded_images/Tephragon_(Extinction)-menu.png": 47646,
	"./downloaded_images/Teslad-menu.png": 59802,
	"./downloaded_images/Teslad.png": 85000,
	"./downloaded_images/Teslad_Cosmic.png": 19331,
	"./downloaded_images/Tesling-menu.png": 92983,
	"./downloaded_images/Tesling.png": 77151,
	"./downloaded_images/Tesling_Cosmic.png": 99346,
	"./downloaded_images/The_Drake_IslesWarp.png": 28259,
	"./downloaded_images/The_OrphanageWarp.png": 10206,
	"./downloaded_images/The_OutlandsWarp.png": 39195,
	"./downloaded_images/Thorn_Pit_EX_SkillIcon.png": 31678,
	"./downloaded_images/Thorn_Storm_EX_SkillIcon.png": 73281,
	"./downloaded_images/Thornox-menu.png": 22269,
	"./downloaded_images/Thornox.png": 96637,
	"./downloaded_images/Thornox_Cosmic.png": 32520,
	"./downloaded_images/Thrammer-menu.png": 37843,
	"./downloaded_images/Thrammer.png": 59864,
	"./downloaded_images/Thrammer_Cosmic.png": 79726,
	"./downloaded_images/Thunder_Blast_EX_SkillIcon.png": 90609,
	"./downloaded_images/Thunder_EX_SkillIcon.png": 55356,
	"./downloaded_images/Tikala2.png": 36649,
	"./downloaded_images/Tikala_(Extinction)-menu.png": 18560,
	"./downloaded_images/Tiki-menu.png": 46592,
	"./downloaded_images/Tiki.png": 18510,
	"./downloaded_images/Tiki_Cosmic.png": 21329,
	"./downloaded_images/Tiliamber-menu.png": 44800,
	"./downloaded_images/Tiliamber.png": 21230,
	"./downloaded_images/Tiliamber_Cosmic.png": 80465,
	"./downloaded_images/Titan2.png": 60723,
	"./downloaded_images/Titan_(Extinction)-menu.png": 42514,
	"./downloaded_images/Tornado_Kick_EX_SkillIcon.png": 85874,
	"./downloaded_images/Torrent_EX_SkillIcon.png": 4016,
	"./downloaded_images/Torrex2.png": 4893,
	"./downloaded_images/Torrex_(Extinction)-menu.png": 66828,
	"./downloaded_images/Toxic_Splash_EX_SkillIcon.png": 41993,
	"./downloaded_images/Trebly-menu.png": 52481,
	"./downloaded_images/Trebly.png": 84241,
	"./downloaded_images/Treclay-menu.png": 21627,
	"./downloaded_images/Treclay.png": 22931,
	"./downloaded_images/Tresaur-menu.png": 55493,
	"./downloaded_images/Tresaur.png": 37797,
	"./downloaded_images/Trondle2.png": 31931,
	"./downloaded_images/Trondle_(Extinction)-menu.png": 73098,
	"./downloaded_images/Tropical_Rain_EX_SkillIcon.png": 81173,
	"./downloaded_images/Tsunami_EX_SkillIcon.png": 34473,
	"./downloaded_images/Tundri-menu.png": 55451,
	"./downloaded_images/Tundri.png": 99827,
	"./downloaded_images/Tundri_Cosmic.png": 77382,
	"./downloaded_images/Tundrox-menu.png": 29897,
	"./downloaded_images/Tundrox.png": 10265,
	"./downloaded_images/Tundrox_Cosmic.png": 36804,
	"./downloaded_images/Tuskant-menu.png": 91013,
	"./downloaded_images/Tuskant.png": 46629,
	"./downloaded_images/Tuskant_Cosmic.png": 64448,
	"./downloaded_images/Twin_Electrode_EX_SkillIcon.png": 44752,
	"./downloaded_images/Twin_Tornado_EX_SkillIcon.png": 61162,
	"./downloaded_images/Tyrake-menu.png": 28005,
	"./downloaded_images/Tyrake.png": 90789,
	"./downloaded_images/Vados-menu.png": 30018,
	"./downloaded_images/Vados.png": 19504,
	"./downloaded_images/Vainok-menu.png": 29839,
	"./downloaded_images/Vainok.png": 62103,
	"./downloaded_images/Vaprat2.png": 28335,
	"./downloaded_images/Vaprat_(Extinction)-menu.png": 70070,
	"./downloaded_images/Varawirl-menu.png": 33917,
	"./downloaded_images/Varawirl.png": 92829,
	"./downloaded_images/Varawirl_Cosmic.png": 50920,
	"./downloaded_images/Venefelis-menu.png": 43476,
	"./downloaded_images/Venefelis.png": 57106,
	"./downloaded_images/Ventra2.png": 47371,
	"./downloaded_images/Ventra_(Extinction)-menu.png": 26394,
	"./downloaded_images/Vine_Shield_EX_SkillIcon.png": 17570,
	"./downloaded_images/Vine_Whip_EX_SkillIcon.png": 25261,
	"./downloaded_images/Virox-menu.png": 32913,
	"./downloaded_images/Virox.png": 93633,
	"./downloaded_images/Virox_Cosmic.png": 40924,
	"./downloaded_images/Vodo-menu.png": 48877,
	"./downloaded_images/Vodo.png": 27309,
	"./downloaded_images/Vodo_Cosmic.png": 36024,
	"./downloaded_images/Volcel-menu.png": 25520,
	"./downloaded_images/Volcel.png": 10366,
	"./downloaded_images/Volnamic-menu.png": 26688,
	"./downloaded_images/Volnamic.png": 28718,
	"./downloaded_images/Volpressor-menu.png": 64118,
	"./downloaded_images/Volpressor.png": 20868,
	"./downloaded_images/Volpressor_Cosmic.png": 81519,
	"./downloaded_images/Volt-menu.png": 52072,
	"./downloaded_images/Volt.png": 98710,
	"./downloaded_images/Volta-menu.png": 91133,
	"./downloaded_images/Volta.png": 75645,
	"./downloaded_images/Voltaic-menu.png": 29537,
	"./downloaded_images/Voltaic.png": 20945,
	"./downloaded_images/Voltosfere2.png": 97632,
	"./downloaded_images/Voltosfere_(Extinction)-menu.png": 57147,
	"./downloaded_images/Wadgon-menu.png": 50459,
	"./downloaded_images/Wadgon.png": 59667,
	"./downloaded_images/Wadtail-menu.png": 97805,
	"./downloaded_images/Wadtail.png": 28429,
	"./downloaded_images/Wargoyle-menu.png": 82955,
	"./downloaded_images/Wargoyle.png": 17699,
	"./downloaded_images/Waser-menu.png": 21121,
	"./downloaded_images/Waser.png": 25841,
	"./downloaded_images/Waser_Cosmic.png": 26988,
	"./downloaded_images/Water_Blast_EX_SkillIcon.png": 17044,
	"./downloaded_images/Water_Type_Icon.png": 49283,
	"./downloaded_images/Watermelon.png": 22085,
	"./downloaded_images/Wave_EX_SkillIcon.png": 68163,
	"./downloaded_images/Weavolt2.png": 68817,
	"./downloaded_images/Weavolt_(Extinction)-menu.png": 79640,
	"./downloaded_images/Whirlpool_EX_SkillIcon.png": 19076,
	"./downloaded_images/Wind_Barrier_EX_SkillIcon.png": 82140,
	"./downloaded_images/Wind_Blast_EX_SkillIcon.png": 13413,
	"./downloaded_images/Wind_Pellet_EX_SkillIcon.png": 59959,
	"./downloaded_images/Wind_Siphon_EX_SkillIcon.png": 60515,
	"./downloaded_images/Wind_Song_EX_SkillIcon.png": 62812,
	"./downloaded_images/Wind_Strike_EX_SkillIcon.png": 77992,
	"./downloaded_images/Wind_Type_Icon.png": 94868,
	"./downloaded_images/Wiselie2.png": 19679,
	"./downloaded_images/Wiselie_(Extinction)-menu.png": 72390,
	"./downloaded_images/Woozy-menu.png": 9297,
	"./downloaded_images/Woozy.png": 62465,
	"./downloaded_images/Woozy_Cosmic.png": 83900,
	"./downloaded_images/Worb-menu.png": 33485,
	"./downloaded_images/Worb.png": 49709,
	"./downloaded_images/Worb_Cosmic.png": 40920,
	"./downloaded_images/Wysil-menu.png": 12795,
	"./downloaded_images/Wysil.png": 5779,
	"./downloaded_images/Wyverne-menu.png": 62675,
	"./downloaded_images/Wyverne.png": 84107,
	"./downloaded_images/X_Slash_EX_SkillIcon.png": 25956,
	"./downloaded_images/Xotor-menu.png": 65949,
	"./downloaded_images/Xotor.png": 45917,
	"./downloaded_images/Xotor_Cosmic.png": 99912,
	"./downloaded_images/Yarnesty-menu.png": 77366,
	"./downloaded_images/Yarnesty.png": 13636,
	"./downloaded_images/Yomnom-menu.png": 12256,
	"./downloaded_images/Yomnom.png": 92878,
	"./downloaded_images/Yummo-menu.png": 39422,
	"./downloaded_images/Yummo.png": 52556,
	"./downloaded_images/Zappnic-menu.png": 93778,
	"./downloaded_images/Zappnic.png": 34720,
	"./downloaded_images/Zappnic_Cosmic.png": 12203,
	"./downloaded_images/Zasp-menu.png": 24601,
	"./downloaded_images/Zasp.png": 34569,
	"./downloaded_images/Zasp_Cosmic.png": 49460,
	"./downloaded_images/Ziegler2.png": 85433,
	"./downloaded_images/Ziegler_(Extinction)-menu.png": 32208,
	"./downloaded_images/Zumble-menu.png": 66526,
	"./downloaded_images/Zumble.png": 1644,
	"./downloaded_images/Zumble_Cosmic.png": 10311,
	"./downloaded_location_images/Amelie's_Lab_Maze.png": 55204,
	"./downloaded_location_images/Amelie's_Lab_Outside.png": 37004,
	"./downloaded_location_images/Amelies_Lab_Room_1.png": 16589,
	"./downloaded_location_images/Cadium_(lab)_Submarine_Dock.png": 90100,
	"./downloaded_location_images/Cadium_(lab)_Warpstone.png": 22021,
	"./downloaded_location_images/Cadium_(lab)_Warpstone_North.png": 81577,
	"./downloaded_location_images/Cadium_Center.png": 42108,
	"./downloaded_location_images/Cadium_Control_Room.png": 54568,
	"./downloaded_location_images/Cadium_East.png": 73760,
	"./downloaded_location_images/Cadium_Generator_Room_1.png": 31544,
	"./downloaded_location_images/Cadium_Generator_Room_2.png": 27155,
	"./downloaded_location_images/Cadium_Generator_Room_3.png": 11594,
	"./downloaded_location_images/Cadium_Generator_Room_3_North.png": 10302,
	"./downloaded_location_images/Cadium_Generator_Room_3_Northeast.png": 83389,
	"./downloaded_location_images/Cadium_Generator_Room_4.png": 82021,
	"./downloaded_location_images/Cadium_Submarine_Dock.png": 44857,
	"./downloaded_location_images/Caelesa's_Doors.png": 31433,
	"./downloaded_location_images/Caelesa's_Location.png": 80233,
	"./downloaded_location_images/Cursed_Tower_-_Crossroads.png": 43163,
	"./downloaded_location_images/Cursed_Tower_-_Crossroads_South.png": 69893,
	"./downloaded_location_images/Cursed_Tower_-_Dead_End.png": 46526,
	"./downloaded_location_images/Cursed_Tower_-_Electric_Path.png": 54037,
	"./downloaded_location_images/Cursed_Tower_-_Electric_Room.png": 36089,
	"./downloaded_location_images/Cursed_Tower_-_Entrance.png": 61460,
	"./downloaded_location_images/Cursed_Tower_-_Fire_Path.png": 64394,
	"./downloaded_location_images/Cursed_Tower_-_Fire_Room.png": 49414,
	"./downloaded_location_images/Cursed_Tower_-_Ice_Puzzle_1.png": 44778,
	"./downloaded_location_images/Cursed_Tower_-_Ice_Puzzle_2.png": 85857,
	"./downloaded_location_images/Cursed_Tower_-_Ice_Puzzle_North.png": 41378,
	"./downloaded_location_images/Cursed_Tower_-_Ice_Puzzle_South.png": 9640,
	"./downloaded_location_images/Cursed_Tower_-_Machine_Room.png": 66617,
	"./downloaded_location_images/Cursed_Tower_-_Meeting_Spot.png": 50500,
	"./downloaded_location_images/Cursed_Tower_-_Multi-Level_Room.png": 98138,
	"./downloaded_location_images/Cursed_Tower_-_Open_Room.png": 32070,
	"./downloaded_location_images/Cursed_Tower_-_T-Path.png": 2178,
	"./downloaded_location_images/Cursed_Tower_-_T-Path_West.png": 93386,
	"./downloaded_location_images/Cursed_Tower_-_Ventra_and_Arqua.png": 76371,
	"./downloaded_location_images/Cursed_Tower_-_Water_Path.png": 29151,
	"./downloaded_location_images/Cursed_Tower_-_Water_Room.png": 21791,
	"./downloaded_location_images/Cursed_Tower_-_Wind_Path.png": 84992,
	"./downloaded_location_images/Cursed_Tower_-_Wind_Room.png": 73984,
	"./downloaded_location_images/Cursed_Tower_Outside.png": 50857,
	"./downloaded_location_images/Cursed_Tower_South.png": 83687,
	"./downloaded_location_images/Derek's_Greenhouse.png": 24460,
	"./downloaded_location_images/Desert_Bridge.png": 16948,
	"./downloaded_location_images/Desert_Broken_Boat.png": 41215,
	"./downloaded_location_images/Desert_Cave_-_Entrance.png": 34459,
	"./downloaded_location_images/Desert_Outpost.png": 79777,
	"./downloaded_location_images/Desert_Outpost_West.png": 90311,
	"./downloaded_location_images/Desert_Outside_Cave.png": 72580,
	"./downloaded_location_images/Desert_Tyrant_Bones.png": 27583,
	"./downloaded_location_images/Desert_Tyrant_Location.png": 55393,
	"./downloaded_location_images/Desert_Tyrant_Location_Camp.png": 22489,
	"./downloaded_location_images/Dock_to_Palmaya.png": 1148,
	"./downloaded_location_images/Dragon_Summoning_Spot.png": 35299,
	"./downloaded_location_images/Drake_Isles_Airship_Dock.png": 80948,
	"./downloaded_location_images/Drake_Isles_Broken_Bridge.png": 92855,
	"./downloaded_location_images/Drake_Isles_Broken_Bridge_North.png": 43635,
	"./downloaded_location_images/Drake_Isles_Cave_-_Center.png": 36291,
	"./downloaded_location_images/Drake_Isles_Cave_-_Drake_Masters.png": 80037,
	"./downloaded_location_images/Drake_Isles_Cave_-_East.png": 61131,
	"./downloaded_location_images/Drake_Isles_Cave_-_Entrance.png": 17494,
	"./downloaded_location_images/Drake_Isles_Cave_-_North.png": 36739,
	"./downloaded_location_images/Drake_Isles_Cave_Outside.png": 2147,
	"./downloaded_location_images/Drake_Isles_City_Ruins.png": 35245,
	"./downloaded_location_images/Drake_Isles_Dragon_Head.png": 39508,
	"./downloaded_location_images/Drake_Isles_Dragon_Head_East.png": 77313,
	"./downloaded_location_images/Drake_Isles_Dragon_Punch.png": 50632,
	"./downloaded_location_images/Drake_Isles_Eurus's_Napping_Spot.png": 7609,
	"./downloaded_location_images/Drake_Isles_Festival.png": 93904,
	"./downloaded_location_images/Drake_Isles_High_Spot.png": 81981,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_Dragons.png": 43650,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_Entrance.png": 6222,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_F0_East.png": 10143,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_F0_West.png": 58582,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_F1_East.png": 38307,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_F1_West.png": 13181,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_F2_East.png": 54545,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_F2_West.png": 87156,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_F3_East.png": 14605,
	"./downloaded_location_images/Drake_Isles_Laboratory_-_Window.png": 39728,
	"./downloaded_location_images/Drake_Isles_Scientist's_House.png": 94967,
	"./downloaded_location_images/Drake_Isles_Scientist's_House_West.png": 46933,
	"./downloaded_location_images/Drake_Isles_Shamisen_Tamer.png": 3328,
	"./downloaded_location_images/Drake_Isles_Tower_Ruins.png": 53421,
	"./downloaded_location_images/Drake_Isles_Tower_Ruins_South.png": 65579,
	"./downloaded_location_images/Drake_Isles_Ventra's_Tomb.png": 11339,
	"./downloaded_location_images/Drake_Isles_Village_Center.png": 21576,
	"./downloaded_location_images/Drake_Isles_Village_Southern_Entrance.png": 62646,
	"./downloaded_location_images/Eliza's_House.png": 98825,
	"./downloaded_location_images/Frozen_Cave_-_Downstairs.png": 90482,
	"./downloaded_location_images/Frozen_Cave_-_East.png": 43947,
	"./downloaded_location_images/Frozen_Cave_-_Entrance.png": 31702,
	"./downloaded_location_images/Frozen_Cave_-_Ladder.png": 34292,
	"./downloaded_location_images/Frozen_Cave_-_South.png": 12481,
	"./downloaded_location_images/Frozen_Cave_-_Tyrant_Room.png": 64064,
	"./downloaded_location_images/Frozen_City.png": 34393,
	"./downloaded_location_images/Frozen_City_Camp.png": 72961,
	"./downloaded_location_images/Frozen_City_Eastern_Entrance.png": 14919,
	"./downloaded_location_images/Frozen_City_Southern_Entrance.png": 94417,
	"./downloaded_location_images/Frozen_City_Western_Entrance.png": 14889,
	"./downloaded_location_images/Frozen_Lake.png": 26389,
	"./downloaded_location_images/Frozen_Tundra_(Base)_Warpstone.png": 99501,
	"./downloaded_location_images/Frozen_Tundra_Bridge.png": 75578,
	"./downloaded_location_images/Frozen_Tundra_Bunker_-_Atlas_Room.png": 3274,
	"./downloaded_location_images/Frozen_Tundra_Bunker_-_Room_1.png": 12526,
	"./downloaded_location_images/Frozen_Tundra_Bunker_-_Room_2.png": 677,
	"./downloaded_location_images/Frozen_Tundra_Bunker_-_Room_3.png": 71260,
	"./downloaded_location_images/Frozen_Tundra_Bunker_Outside.png": 96038,
	"./downloaded_location_images/Frozen_Tundra_Eastern_Cave.png": 17469,
	"./downloaded_location_images/Frozen_Tundra_Eastern_Cave_Outside.png": 91245,
	"./downloaded_location_images/Frozen_Tundra_Explosives_House.png": 27380,
	"./downloaded_location_images/Frozen_Tundra_Frozen_Ruins.png": 22463,
	"./downloaded_location_images/Frozen_Tundra_Frozen_Ruins_West.png": 41469,
	"./downloaded_location_images/Frozen_Tundra_House_Ruins.png": 74833,
	"./downloaded_location_images/Frozen_Tundra_Lake.png": 34744,
	"./downloaded_location_images/Frozen_Tundra_Nexolord_Statue.png": 48577,
	"./downloaded_location_images/Frozen_Tundra_River.png": 96623,
	"./downloaded_location_images/Frozen_Tundra_Snowy_Ruins.png": 24899,
	"./downloaded_location_images/Frozen_Tundra_Southern_Cave_-_East.png": 48381,
	"./downloaded_location_images/Frozen_Tundra_Southern_Cave_-_Entrance.png": 74044,
	"./downloaded_location_images/Frozen_Tundra_Southern_Cave_-_Southeast.png": 21892,
	"./downloaded_location_images/Frozen_Tundra_Southern_Cave_-_West.png": 3483,
	"./downloaded_location_images/Frozen_Tundra_Southern_Cave_Outside.png": 57025,
	"./downloaded_location_images/Frozen_Tundra_Tyrant_Bones.png": 36485,
	"./downloaded_location_images/Grunda's_Cave_-_B1.png": 6440,
	"./downloaded_location_images/Grunda's_Cave_-_B2.png": 91715,
	"./downloaded_location_images/Grunda's_Cave_-_Bones.png": 39442,
	"./downloaded_location_images/Grunda's_Cave_-_Entrance.png": 98941,
	"./downloaded_location_images/Grunda's_Cave_-_North.png": 11422,
	"./downloaded_location_images/Grunda's_Cave_-_West.png": 89074,
	"./downloaded_location_images/Grunda's_Cave_Outside.png": 25714,
	"./downloaded_location_images/Haunted_Woods_Bridge.png": 92409,
	"./downloaded_location_images/Haunted_Woods_Bridge_End.png": 38451,
	"./downloaded_location_images/Haunted_Woods_Broken_Tower.png": 84043,
	"./downloaded_location_images/Haunted_Woods_Cave_-_Entrance.png": 4160,
	"./downloaded_location_images/Haunted_Woods_Cave_-_North.png": 73261,
	"./downloaded_location_images/Haunted_Woods_Cave_-_Northeast.png": 26946,
	"./downloaded_location_images/Haunted_Woods_Cave_-_West.png": 2623,
	"./downloaded_location_images/Haunted_Woods_Eastern_Camp.png": 25922,
	"./downloaded_location_images/Haunted_Woods_Lake.png": 40495,
	"./downloaded_location_images/Haunted_Woods_Northern_Entrance.png": 80895,
	"./downloaded_location_images/Haunted_Woods_Outside_Cave.png": 42429,
	"./downloaded_location_images/Haunted_Woods_Southern_Entrance.png": 79237,
	"./downloaded_location_images/Haunted_Woods_Tyrant_Bones.png": 71366,
	"./downloaded_location_images/Helovolk's_Cave_-_Entrance.png": 46278,
	"./downloaded_location_images/Helovolk's_Cave_-_Helovolk's_Location.png": 51858,
	"./downloaded_location_images/Hero's_Tomb_-_Entrance.png": 75125,
	"./downloaded_location_images/Hero's_Tomb_-_North.png": 26518,
	"./downloaded_location_images/Hidden_Village_Center.png": 47618,
	"./downloaded_location_images/Hidden_Village_Hilda's_House.png": 31952,
	"./downloaded_location_images/Hidden_Village_Nara's_Tomb.png": 38106,
	"./downloaded_location_images/Hidden_Village_Southern_Entrance.png": 20660,
	"./downloaded_location_images/Hidden_Village_Tikala's_Tree.png": 11968,
	"./downloaded_location_images/Hidden_Village_West.png": 76396,
	"./downloaded_location_images/Ignitia_Big_Lava_Lake.png": 47700,
	"./downloaded_location_images/Ignitia_Drill_Vehicle.png": 95081,
	"./downloaded_location_images/Ignitia_Drill_Vehicle_Northwest.png": 56592,
	"./downloaded_location_images/Ignitia_Drill_Vehicle_Southwest.png": 85746,
	"./downloaded_location_images/Ignitia_Elevator_Bottom.png": 64235,
	"./downloaded_location_images/Ignitia_Elevator_South.png": 4899,
	"./downloaded_location_images/Ignitia_Elevator_Top.png": 7537,
	"./downloaded_location_images/Ignitia_Fona's_Tomb.png": 47794,
	"./downloaded_location_images/Ignitia_Fona's_Tomb_South.png": 77548,
	"./downloaded_location_images/Ignitia_Frozen_Lava.png": 75576,
	"./downloaded_location_images/Ignitia_Frozen_Lava_South.png": 35214,
	"./downloaded_location_images/Ignitia_Giant_Crystal.png": 92851,
	"./downloaded_location_images/Ignitia_Lone_House.png": 57658,
	"./downloaded_location_images/Ignitia_Mining_Shop.png": 9620,
	"./downloaded_location_images/Ignitia_Northern_Cave_-_Center.png": 31545,
	"./downloaded_location_images/Ignitia_Northern_Cave_-_Entrance.png": 46712,
	"./downloaded_location_images/Ignitia_Northern_Cave_-_North.png": 6789,
	"./downloaded_location_images/Ignitia_Northern_Cave_Outside.png": 66949,
	"./downloaded_location_images/Ignitia_Northern_Entrance.png": 62692,
	"./downloaded_location_images/Ignitia_Shops.png": 25444,
	"./downloaded_location_images/Ignitia_Southeastern_Entrance.png": 57917,
	"./downloaded_location_images/Ignitia_Southern_Cave_-_East.png": 54803,
	"./downloaded_location_images/Ignitia_Southern_Cave_-_Entrance.png": 18398,
	"./downloaded_location_images/Ignitia_Southern_Cave_-_North.png": 42059,
	"./downloaded_location_images/Ignitia_Southern_Cave_-_West.png": 71597,
	"./downloaded_location_images/Ignitia_Southern_Cave_Outside.png": 86107,
	"./downloaded_location_images/Ignitia_Thirsty_Guy.png": 91686,
	"./downloaded_location_images/Ignitia_Thirsty_Guy_South.png": 53200,
	"./downloaded_location_images/Ignitia_Tyrant_Bones.png": 84175,
	"./downloaded_location_images/Ignitia_Water_Tank.png": 72267,
	"./downloaded_location_images/Ignitia_Western_Entrance.png": 19568,
	"./downloaded_location_images/Immortal_Citadel.png": 69767,
	"./downloaded_location_images/Immortal_Citadel_Camp.png": 80819,
	"./downloaded_location_images/Immortal_Citadel_Eastern_Entrance.png": 23461,
	"./downloaded_location_images/Immortal_Citadel_Southern_Entrance.png": 98895,
	"./downloaded_location_images/Inominox_Camp.png": 10522,
	"./downloaded_location_images/Inominox_Camp_South.png": 6724,
	"./downloaded_location_images/Inominox_Location.png": 80416,
	"./downloaded_location_images/Khan_Woods_Cave_-_Entrance.png": 76943,
	"./downloaded_location_images/Khan_Woods_Cave_-_F1.png": 50458,
	"./downloaded_location_images/Khan_Woods_Cave_-_F2.png": 26705,
	"./downloaded_location_images/Khan_Woods_Cave_Outside.png": 58748,
	"./downloaded_location_images/Khan_Woods_Entrance.png": 8301,
	"./downloaded_location_images/Khan_Woods_Entrance_West.png": 2443,
	"./downloaded_location_images/Khan_Woods_Giant_Mushrooms.png": 67212,
	"./downloaded_location_images/Khan_Woods_Tunnel_-_East.png": 19221,
	"./downloaded_location_images/Khan_Woods_Tunnel_-_Entrance.png": 2388,
	"./downloaded_location_images/Khan_Woods_Tunnel_-_Exit.png": 63782,
	"./downloaded_location_images/Khan_Woods_Tunnel_-_North.png": 67385,
	"./downloaded_location_images/Khan_Woods_Tunnel_-_West.png": 62291,
	"./downloaded_location_images/Khan_Woods_Tunnel_Outside.png": 98281,
	"./downloaded_location_images/Khan_Woods_Tunnel_Outside_West.png": 7183,
	"./downloaded_location_images/Kroma's_Camp.png": 82483,
	"./downloaded_location_images/Kroma's_Camp_North.png": 98383,
	"./downloaded_location_images/Kroma's_Location.png": 11469,
	"./downloaded_location_images/Lateria_Barracks.png": 96407,
	"./downloaded_location_images/Lateria_Barracks_South.png": 64593,
	"./downloaded_location_images/Lateria_Cannons.png": 57158,
	"./downloaded_location_images/Lateria_Cannons_North.png": 67866,
	"./downloaded_location_images/Lateria_Eastern_Entrance.png": 64175,
	"./downloaded_location_images/Lateria_Observatory.png": 51580,
	"./downloaded_location_images/Lateria_Prison.png": 78711,
	"./downloaded_location_images/Lateria_Prison_South.png": 83537,
	"./downloaded_location_images/Lateria_Shops.png": 58463,
	"./downloaded_location_images/Lateria_Shops_South.png": 89737,
	"./downloaded_location_images/Lateria_Western_Entrance.png": 83793,
	"./downloaded_location_images/Logan's_House.png": 39097,
	"./downloaded_location_images/Logan's_House_South.png": 56103,
	"./downloaded_location_images/Magic_Shop.png": 65917,
	"./downloaded_location_images/Mandrasses_Cemetery.png": 56349,
	"./downloaded_location_images/Mega_Arena_of_Doom.png": 17343,
	"./downloaded_location_images/Mega_Arena_of_Doom_East.png": 85987,
	"./downloaded_location_images/Nexolord_Cemetery.png": 6565,
	"./downloaded_location_images/North_of_Haunted_Woods_Bridge.png": 11999,
	"./downloaded_location_images/Orphanage.png": 63082,
	"./downloaded_location_images/Orphanage_East.png": 31408,
	"./downloaded_location_images/Orphanage_South.png": 29524,
	"./downloaded_location_images/Orphanage_Western_Camp.png": 38165,
	"./downloaded_location_images/Outlands_Camp.png": 87415,
	"./downloaded_location_images/Outlands_Eastern_Cave_-_B1.png": 48706,
	"./downloaded_location_images/Outlands_Eastern_Cave_-_B1_West.png": 42474,
	"./downloaded_location_images/Outlands_Eastern_Cave_-_B2.png": 15289,
	"./downloaded_location_images/Outlands_Eastern_Cave_-_B2_East.png": 20025,
	"./downloaded_location_images/Outlands_Eastern_Cave_-_Entrance.png": 87267,
	"./downloaded_location_images/Outlands_Eastern_Cave_Outside.png": 56152,
	"./downloaded_location_images/Outlands_Southern_Cave_-_East.png": 21060,
	"./downloaded_location_images/Outlands_Southern_Cave_-_Eastern_End.png": 81501,
	"./downloaded_location_images/Outlands_Southern_Cave_-_Entrance.png": 28649,
	"./downloaded_location_images/Outlands_Southern_Cave_-_West.png": 97838,
	"./downloaded_location_images/Outlands_Southern_Cave_-_Western_End.png": 30835,
	"./downloaded_location_images/Outlands_Southern_Cave_Outside.png": 97942,
	"./downloaded_location_images/Outskirts_Bridge.png": 89241,
	"./downloaded_location_images/Outskirts_Bridge_East.png": 28825,
	"./downloaded_location_images/Outskirts_Bridge_West.png": 37375,
	"./downloaded_location_images/Outskirts_Cave_-_East.png": 91225,
	"./downloaded_location_images/Outskirts_Cave_-_Entrance.png": 21472,
	"./downloaded_location_images/Outskirts_Cave_-_North.png": 39181,
	"./downloaded_location_images/Outskirts_Cave_-_West.png": 83295,
	"./downloaded_location_images/Outskirts_Outside_Cave.png": 85341,
	"./downloaded_location_images/Outskirts_Submarine.png": 55916,
	"./downloaded_location_images/Palmaya_Crossroads.png": 92806,
	"./downloaded_location_images/Palmaya_Dragon_Summoning_Spot.png": 24066,
	"./downloaded_location_images/Palmaya_Northwest_Corner.png": 70191,
	"./downloaded_location_images/Palmaya_Port.png": 43194,
	"./downloaded_location_images/Palmaya_Port_South.png": 36196,
	"./downloaded_location_images/Palmaya_Port_Southeast.png": 68927,
	"./downloaded_location_images/Palmaya_Shops.png": 8932,
	"./downloaded_location_images/Palmaya_Shops_South.png": 15194,
	"./downloaded_location_images/Palmaya_Southern_Entrance.png": 18750,
	"./downloaded_location_images/Palmaya_Trapmaker's_House.png": 90451,
	"./downloaded_location_images/Palmaya_Trapmaker's_House_East.png": 77543,
	"./downloaded_location_images/Palmaya_Trapmaker's_House_North.png": 36879,
	"./downloaded_location_images/Palmaya_Western_Entrance.png": 61360,
	"./downloaded_location_images/Parum_City_Center.png": 91924,
	"./downloaded_location_images/Parum_City_East.png": 69416,
	"./downloaded_location_images/Parum_City_Guild.png": 58134,
	"./downloaded_location_images/Parum_City_Laboratories.png": 90416,
	"./downloaded_location_images/Parum_City_Laboratories_East.png": 46794,
	"./downloaded_location_images/Parum_City_Northern_Entrance.png": 11176,
	"./downloaded_location_images/Parum_City_Outside_Airship_Hangar.png": 74671,
	"./downloaded_location_images/Parum_City_Southern_Entrance.png": 4322,
	"./downloaded_location_images/Parum_City_Submarine.png": 21927,
	"./downloaded_location_images/Parum_City_West.png": 22090,
	"./downloaded_location_images/Path_to_Dock.png": 85786,
	"./downloaded_location_images/Pluvean_Cave_-_Room_1.png": 40932,
	"./downloaded_location_images/Pluvean_Cave_-_Room_2.png": 95583,
	"./downloaded_location_images/Pluvean_Cave_-_Room_3.png": 99254,
	"./downloaded_location_images/Pluvean_Cave_Northeast.png": 4503,
	"./downloaded_location_images/Pluvean_Cave_Outside.png": 196,
	"./downloaded_location_images/Pluvean_Cave_Southeast.png": 93069,
	"./downloaded_location_images/Pluvean_Location.png": 68810,
	"./downloaded_location_images/Precursor_Valley_Basecamp.png": 91621,
	"./downloaded_location_images/Precursor_Valley_Basecamp_East.png": 73989,
	"./downloaded_location_images/Precursor_Valley_Basecamp_South.png": 42675,
	"./downloaded_location_images/Precursor_Valley_Dark_Cave_-_Entrance.png": 62180,
	"./downloaded_location_images/Precursor_Valley_Dark_Cave_-_Laboratory.png": 22417,
	"./downloaded_location_images/Precursor_Valley_Dark_Cave_-_North.png": 77801,
	"./downloaded_location_images/Precursor_Valley_Dark_Cave_-_West.png": 99075,
	"./downloaded_location_images/Precursor_Valley_Dark_Cave_Outside.png": 13945,
	"./downloaded_location_images/Precursor_Valley_Dark_Maze.png": 18431,
	"./downloaded_location_images/Precursor_Valley_End.png": 1438,
	"./downloaded_location_images/Precursor_Valley_Engraved_Stones.png": 25744,
	"./downloaded_location_images/Precursor_Valley_Engraved_Stones_South.png": 42966,
	"./downloaded_location_images/Precursor_Valley_Engraved_Stones_West.png": 64584,
	"./downloaded_location_images/Precursor_Valley_Forest_Entrance.png": 57309,
	"./downloaded_location_images/Precursor_Valley_Forest_North.png": 80158,
	"./downloaded_location_images/Precursor_Valley_Giant_Pot.png": 14958,
	"./downloaded_location_images/Precursor_Valley_Hot_Cave_-_Braccus'_Location.png": 53127,
	"./downloaded_location_images/Precursor_Valley_Hot_Cave_-_Braccus'_Path.png": 5735,
	"./downloaded_location_images/Precursor_Valley_Hot_Cave_-_Middle_Path.png": 79624,
	"./downloaded_location_images/Precursor_Valley_Hot_Cave_-_Northern_Entrance.png": 4352,
	"./downloaded_location_images/Precursor_Valley_Hot_Cave_-_Southern_Entrance.png": 53258,
	"./downloaded_location_images/Precursor_Valley_Hot_Cave_Outside.png": 15298,
	"./downloaded_location_images/Precursor_Valley_Landing_Spot.png": 94889,
	"./downloaded_location_images/Precursor_Valley_Logan's_Laboratory.png": 6670,
	"./downloaded_location_images/Precursor_Valley_Logan's_Laboratory_Outside.png": 25934,
	"./downloaded_location_images/Precursor_Valley_Lost_Map_Piece.png": 66871,
	"./downloaded_location_images/Precursor_Valley_Map.png": 25079,
	"./downloaded_location_images/Precursor_Valley_Map_South.png": 82001,
	"./downloaded_location_images/Precursor_Valley_Pattern_Maze_Camp.png": 54765,
	"./downloaded_location_images/Precursor_Valley_Shortcut_Guy.png": 84415,
	"./downloaded_location_images/Ron_and_Willy_Cemetery.png": 54799,
	"./downloaded_location_images/Rotramus_Location.png": 71288,
	"./downloaded_location_images/Royalle_City_Ruins_-_Nexomon_Center.png": 9422,
	"./downloaded_location_images/Royalle_City_Ruins_-_Shop.png": 32380,
	"./downloaded_location_images/Royalle_City_Ruins_-_Spencer's_House.png": 70763,
	"./downloaded_location_images/Royalle_City_Ruins_South.png": 84633,
	"./downloaded_location_images/Salem's_Labyrinth.png": 55173,
	"./downloaded_location_images/Salem's_Location.png": 23307,
	"./downloaded_location_images/Sirnymfa_Building.png": 75261,
	"./downloaded_location_images/South_Ignitia_Warpstone.png": 94908,
	"./downloaded_location_images/Spencer's_Vault.png": 44608,
	"./downloaded_location_images/Talking_Tree.png": 45012,
	"./downloaded_location_images/Training_Woods_Crossroads.png": 79156,
	"./downloaded_location_images/Training_Woods_East.png": 45326,
	"./downloaded_location_images/Training_Woods_North.png": 84632,
	"./downloaded_location_images/Training_Woods_West.png": 27716,
	"./downloaded_location_images/Venefelis_Camp.png": 41222,
	"./downloaded_location_images/Venefelis_Camp_North.png": 50106,
	"./downloaded_location_images/Venefelis_Location.png": 46332,
	"./downloaded_location_images/West_Ignitia_Warpstone.png": 48962,
	"./downloaded_location_images/Zetta's_House.png": 61154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72014;